<template>
  <patient-profile>
    <modal-dialog-prevent-leave
      v-bind:confirm-button-disabled="isDisabledPreventLeaveSaveButton"
      v-bind:is-shown="isShownDialogLeaveConfirm"
      v-on:back="isShownDialogLeaveConfirm = false"
      v-on:leave="leaveWithoutSave"
      v-on:save="saveAndLeave"
    />
    <mobile-fixed-bottom-popup
      v-if="shownWorkOnPCMobilePopup"
      v-on:close="onCloseWorkOnPCMobileAppPopup"
    >
      Совет. Работать в программе удобнее с компьютера.
    </mobile-fixed-bottom-popup>
    <iframe
      class="patient-profile__print"
      ref="printView"
      title="printView"
    />
    <modal-dialog
      title=""
      v-model="isShowImage"
      v-if="imageSource"
      with-cross
    >
      <div class="show-image__container">
        <img alt="Изображение" v-bind:src="imageSource" />
      </div>
    </modal-dialog>
    <modal-dialog
      v-bind:title="inputDialogDiaryPhraseLibraryTitle"
      v-model="shownPhraseLibraryDialog"
      v-on:input="closePhraseLibraryDialog"
      with-cross
    >
      <form
        v-if="shownCreatePhraseForm"
        ref="form"
        v-on:submit.prevent="onSavePhrase"
      >
        <input-autocomplete
          option-title-key="title"
          option-value-key="id"
          title="Группа"
          v-bind:options="selectedDiaryLibraryGroups"
          v-model="selectedGroupId"
        />
        <textarea-length-limitation
          rows="4"
          v-bind:show-counter="false"
          v-bind:title="inputDialogDiaryPhraseLibraryTitle"
          v-model="editedPhrase" />
        <button
          type="submit"
          class="patient-profile__modal__button"
        >{{ titleSaveButton }}</button>
      </form>
      <form
        v-if="shownCreateGroupForm"
        ref="form"
        v-on:submit.prevent="onSaveGroup"
      >
        <textarea-length-limitation
          rows="1"
          v-bind:max-length="200"
          v-bind:show-counter="false"
          v-bind:title="inputDialogDiaryPhraseLibraryTitle"
          v-model="editingGroupTitle" />
        <button
          type="submit"
          class="patient-profile__modal__button"
        >{{ titleSaveButton }}</button>
      </form>
    </modal-dialog>
    <picker-services
      v-bind:title="selectedPriceListName"
      position-start
      with-select-teeth
      v-bind:with-previous-button="true"
      v-bind:price-list-name="selectedPriceListName"
      v-bind:initial-category-list="selectedCategories"
      v-bind:shown-accordion="shownAccordionServices"
      v-bind:matched-service-list="matchedServiceList"
      v-bind:selected-services-ids="selectedServicesIds"
      v-on:on-previous-button="onPreviousButton"
      v-on:input="searchQuery = ''"
      v-model="shownAddingServicesFromPriceModal"
      v-on:add-service="onAddingPriceService(invoiceTab, $event)"
    >
      <template v-slot:header>
        <input-text-search
          class="patient-visits__services__search-input"
          placeholder="Услуга, код клиники"
          v-bind:is-loading="isAwaitLoadingMatchedServices"
          v-bind:violations="searchInputViolations"
          v-model="searchQuery"
        />
      </template>
      <template
        v-slot:default="{
          emitAddService,
          selectedServices,
        }">
        <matched-service-list
          v-bind:show-price-name="false"
          v-bind:matched-service-list="matchedServiceList"
          v-bind:selectedServices="selectedServices"
          v-bind:selected-services-ids="selectedServicesIds"
          v-on:select-service="emitAddService"
        />
      </template>
    </picker-services>
    <picker-services
      title="Выберите услуги из планов лечения"
      v-bind:initial-treatment-plan-list="treatmentPlanList"
      v-bind:shown-accordion="shownAccordionServices"
      v-bind:selected-services-ids="selectedServicesIds"
      v-model="shownAddingServicesFromTreatmentPlansModal"
      v-on:add-service="onAddingTreatmentPlanService"
      v-on:submit="onSubmitAddingTreatmentPlanServices"
    >
      <template v-slot:after-body="{ selectedServices }">
        <div>
          Будет добавлено позиций: <b>{{ selectedServices.count() }}</b> на сумму:
          <b>
            <the-rub
              v-bind:kop="getSelectedTreatmentPlanServicesAmount(selectedServices)"
              currency="тнг"
            />
          </b>
        </div>
      </template>
    </picker-services>
    <collapse-button
      class="patient-visits__section"
      caption="Визиты"
      v-bind:initial-show="true"
    >
      <the-carousel
        class="patient-visits__slider"
        v-bind:selected-slide="selectedSlide"
        v-bind:carousel-options="carouselOptions"
        v-if="visitList.length !== 0 && !isAwaitRequest"
      >
        <button
          v-for="{ visitFromList, to } in carouselVisitList"
          class="patient-visits__slide"
          v-bind:class="{ active: visitFromList.id === selectedVisitId }"
          type="button"
          v-bind:disabled="isAwaitRequest"
          v-bind:key="visitFromList.id"
          v-on:click="toAnotherVisit(to)"
        >
          <div v-if="hasBranchSystem" class="patient-visits__slide__row">
            <div class="patient-visits__slide__name">{{ visitFromList.branchName }}</div>
          </div>
          <div class="patient-visits__slide__times">
            <time>{{ visitFromList.dateTitle }}</time>
            <time>{{ visitFromList.timeTitle }}</time>
          </div>
          <div class="patient-visits__slide__text">
            Врач: {{ visitFromList.employeeName }}
          </div>
          <div class="patient-visits__slide__text" v-if="visitFromList.teeth">
            <span>Зуб: {{ visitFromList.teeth }}</span>
          </div>
          <div class="patient-visits__slide__diseases-text" v-if="visitFromList.diseases">
            <p>МКБ: {{ visitFromList.diseases }}</p>
          </div>
        </button>
      </the-carousel>
      <the-carousel
        class="patient-visits__slider"
        key="placeholder-carousel"
        v-else
      >
        <div class="patient-visits__slide" />
      </the-carousel>
    </collapse-button>
    <article
      class="visit-iemk-status"
      v-bind:class="iemkStatus"
      v-if="needShowIemkStatus">
      {{ iemkStatusDescription }}
    </article>
    <article
      class="visit-chief-physician-status"
      v-if="restrictEditingVisit && visitIsLoaded">
      <div class="visit-chief-physician-status__title">
        {{ restrictMessage }}
      </div>
    </article>
    <article
      class="visit-chief-physician-status"
      v-bind:class="iemkStatus"
      v-if="needShowChiefPhysicianStatus && canCheckCdaFields">
      <div
        class="visit-chief-physician-status__title"
        v-bind:class="chiefPhysicianStatusId">{{ chiefPhysicianStatusTitle }}</div>
      <p v-if="chiefPhysicianStatusNote">{{ chiefPhysicianStatusNote }}</p>
    </article>
    <form
      class="patient-visits"
      v-on:submit.prevent
    >
      <button
        type="button"
        v-if="isEmpty"
        class="patient-visits__empty"
        v-on:click="onCreateNewVisit()"
      ><b>Создать</b> визит</button>
      <patient-section-control
        class="patient-visits__sections"
        v-model="openedSectionIndexes"
        v-else-if="visit"
      >
        <patient-section :label="''" class="patient-visits__dental-formula">
          <template slot="header">
            <div class="patient-visits__visit__bite">
              <p>Зубная формула</p>
              <div class="patient-visits__visit__bite__container">
                <the-select
                  class="patient-visits__visit__bite__select"
                  v-bind:options="$options.biteOptions"
                  v-model="biteMode"
                  v-on:click.native.stop
                />
                <div class="patient-visits__visit__bite__switch">
                  <div class="patient-visits__visit__bite__title">Детальная формула</div>
                  <input
                    type="checkbox"
                    class="patient-visits__visit__checkbox"
                    v-bind:class="{ 'disable-component': restrictEditingVisit }"
                    v-on:click.stop
                    v-on:input="onSwitchDetailDentalFormula"
                    v-model="isDetailedDentalFormula"
                    id="DetailedDentalFormula"
                    v-bind:readonly="restrictEditingVisit"
                  />
                  <label
                    v-bind:class="{ 'disable-component': restrictEditingVisit }"
                    for="DetailedDentalFormula"
                    v-on:click.stop
                  />
                </div>
              </div>
            </div>
          </template>
          <div v-if="isDetailedDentalFormula">
            Выберите зуб или несколько зубов и добавьте состояние (для выбора нескольких зубов
            зажмите кнопку ctrl на клавиатуре)
            <dental-formula
              v-bind:diagnoses="dentalFormulaDiagnoses"
              v-bind:bite-mode="biteMode"
              v-bind:teeth="dentalFormulaTeeth"
              v-bind:disabled="restrictEditingVisit"
              v-on:change-teeth="onChangeTeeth"
              v-on:change-tooth-diagnoses="onChangeToothDiagnoses"
              v-on:change-tooth-part-diagnoses="onChangeToothPartDiagnoses"
            />
          </div>
          <div v-else class="patient-visits__visit__oral__container">
            <oral-examination
              v-bind:diagnoses="$options.diagnosisList"
              v-bind:teeth="teethDentalCavities"
              v-bind:disabled="restrictEditingVisit"
              v-on:tooth-change="onToothChange"
            />
            <div class="patient-visits__visit__oral__legend">
              <div class="patient-visits__caption">Условные обозначения:</div>
              <div class="patient-visits__visit__oral__legend__items">
                <div
                  class="patient-visits__visit__oral__legend__item"
                  v-for="{ name, description } in $options.diagnosisLegends"
                  v-bind:key="name">
                  <div class="patient-visits__visit__oral__legend__item__name">
                    {{ name }}
                  </div>
                  -
                  <div class="patient-visits__visit__oral__legend__item__description">
                    {{ description }}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button
                class="patient-visits__print-button"
                type="button"
                v-on:click="onPrintVisitFormulaTeeth"
              >
                Печать
              </button>
            </div>
          </div>
        </patient-section>
        <patient-section
          label="Протоколы приема"
          ref="diariesContainer"
          v-bind:description="diariesTitle"
        >
          <the-tooltip v-if="restrictEditingBranchVisit && !hasDiaries" position="top">
            <template v-slot:trigger="{ listenerObject }">
              <button
                disabled
                class="patient-visits__protocol__add min"
                type="button"
                title="Добавить протокол"
                aria-label="Добавить протокол"
                v-on="listenerObject"
              >Добавить протокол</button>
            </template>
            {{ restrictMessage }}
          </the-tooltip>
          <button
            v-bind:class="{ 'disable-component': restrictEditingVisit }"
            v-else-if="!hasDiaries"
            type="button"
            class="patient-visits__protocol__add min"
            v-on:click.stop="createDiary"
          >Добавить протокол</button>
          <template v-if="hasDiaries">
            <the-tabs
              v-bind:key="`tabs-diary-${diaryTabKey}`"
              v-bind:items="diaries"
              v-model="diaryTab"
            >
              <template v-slot:default="{ item, itemIndex } ">
                <div class="patient-visits__diary__tab">
                  <div class="patient-visits__diary__tab__head">
                    <p v-if="indexEditDiaryName !== itemIndex">{{ item.name }}</p>
                    <input
                      class="patient-visits__protocol__name"
                      v-bind:ref="`diaryName-${itemIndex}`"
                      v-else
                      v-model="item.name"
                      v-on:blur="indexEditDiaryName = null; ++diaryTabKey"
                    />
                    <button
                      v-if="diaryTab === itemIndex"
                      class="patient-visits__protocol__icon-edit"
                      type="button"
                      v-on:click="showInputDiaryName(itemIndex)"
                    />
                    <div
                      v-for="(error, index) in inputDiaryNameErrors"
                      v-bind:key="index"
                      class="textarea-length-limitation__validate-error"
                    >{{ error }}</div>
                  </div>
                  <!-- </div> -->
                  <p v-if="doctorAssistanceExists" class="patient-visits__diary__tab__name">
                    {{ item.author.name }}
                  </p>
                </div>
                <button
                  v-if="!restrictEditingVisit && !item.disabled"
                  type="button"
                  v-on:click.prevent.stop="onDeleteDiary(itemIndex)"
                  class="patient-visits__protocol__delete"
                />
              </template>
            </the-tabs>
            <tabs-items
              class="patient-visits__diary__tabs"
              tab-class="diary-tab"
              v-bind:items="diaries"
              v-model="diaryTab"
            >
              <template v-slot:default="{ item, itemIndex }">
                <div class="patient-visits__diary__column" v-bind:class="{ 'disable-component': restrictEditingVisit || item.disabled }">
                  <popover-menu>
                    <template v-slot:trigger="{ listenerObject }">
                      <div
                        class="patient-visits__diary tooth"
                        title="Выберите зубы"
                        v-on="listenerObject"
                        v-if="shownToothIconDiary(itemIndex)">
                        Выберите зубы:
                      </div>
                      <div
                        class="patient-visits__diary__text"
                        title="Выберите зубы"
                        v-on="listenerObject"
                        v-else>
                        Выберите зубы:
                        <span>{{ teethTextDiary(itemIndex) }}</span>
                      </div>
                    </template>
                    <teeth-select-popup
                      v-on:submit="
                        addToDiariesFields(itemIndex, ...arguments);
                        onSubmitTeethDiary(itemIndex, ...arguments);"
                      v-bind:initial-selected="item.teeth"
                      v-bind:initial-dental-parts="item.dentalParts"
                    />
                  </popover-menu>
                  <div
                    v-for="(error, index) in inputDiaryTeethErrors"
                    v-bind:aria-invalid="inputDiaryTeethErrors.length > 0"
                    v-bind:key="index"
                    class="text__violation"
                  >{{ error }}</div>
                  <div
                    v-if="hasDiaryTemplates && diaryTemplatesIsLoaded"
                    class="patient-plans__plan__search print-hide"
                  >
                    <search-input
                      label="Выберите шаблон"
                      placeholder="Название шаблона"
                      item-text="title"
                      item-value="value"
                      v-bind:has-open-modal="true"
                      v-bind:items="optionsOfDiaryTemplates"
                      v-on:input="onApplyDiaryTemplate"
                      v-on:open-modal="onShowDiaryTemplateDialog(itemIndex)"
                      v-bind:value="diaries[diaryTab].templateId"
                    />
                  </div>
                  <div class="patient-visits__diary__description">
                    {{ item.description }}
                  </div>
                  <form-visit-diary
                    v-bind:disabled-field="restrictEditingVisit || item.disabled"
                    v-bind:initial-complaints="item.complaints"
                    v-bind:initial-dental-anamnesis="item.dentalAnamnesis"
                    v-bind:initial-diagnosis="item.diagnosis"
                    v-bind:initial-guarantees="item.guarantees"
                    v-bind:initial-objectively="item.objectively"
                    v-bind:initial-recommendations="item.recommendations"
                    v-bind:initial-sanitized="visit.sanitized"
                    v-bind:initial-studies="item.studies"
                    v-bind:initial-treatment="item.treatment"
                    v-bind:errors-complaints="inputComplaintsErrors"
                    v-bind:errors-diagnosis="inputAnamnesisDiagnosisErrors"
                    v-bind:errors-dental-anamnesis="inputDentalAnamnesisErrors"
                    v-bind:errors-guarantees="inputGuaranteesErrors"
                    v-bind:errors-objectively="inputObjectivelyErrors"
                    v-bind:errors-recommendations="inputRecommendationsErrors"
                    v-bind:errors-studies="inputStudiesErrors"
                    v-bind:errors-treatment="inputTreatmentErrors"
                    v-bind:general-analysis="item.generalAnalysis"
                    v-bind:prognosis="item.prognosis"
                    v-bind:status-lokalis="item.statusLokalis"
                    v-bind:without-editable-sanitized="diarySanitizedNotEditable"
                    v-on:blur-field="onBlurDiaryLibrary"
                    v-on:focus-field="onDiaryFieldFocus"
                    v-on:clear-phrases="onClearSelectedPhrases"
                    v-on:input-complaints="item.complaints = $event"
                    v-on:input-dental-anamnesis="item.dentalAnamnesis = $event"
                    v-on:input-diagnosis="item.diagnosis = $event"
                    v-on:input-guarantees="item.guarantees = $event"
                    v-on:input-objectively="item.objectively = $event"
                    v-on:input-recommendations="item.recommendations = $event"
                    v-on:input-sanitized="visit.sanitized = $event"
                    v-on:input-status-lokalis="item.statusLokalis = $event"
                    v-on:input-studies="item.studies = $event"
                    v-on:input-treatment="item.treatment = $event"
                  >
                    <template v-slot:icd>
                      <div class="patient-visits__diary__block">
                        МКБ-10 <span class="patient-visits__diary__disease">{{ getDiaryDiseaseName(item) }}</span>
                        <input-disease-search
                          class="patient-visits__diary__search"
                          v-bind:key="`diary-mkb-${itemIndex}`"
                          v-bind:loading="isDiseasesLoad"
                          v-bind:options="diseaseList"
                          v-bind:violations="inputIcdErrors"
                          v-model="item.icdId"
                          v-on:search-input="onTextChange"
                          v-on:show-disease-dialog="onShowDiseasesDialog(itemIndex)"
                        >
                          <template v-slot:before-icon>
                            <div class="patient-visits__diary__icon-search" />
                          </template>
                          <template v-slot:after-icon>
                            <button
                              type="button"
                              v-on:click="onShowDiseasesDialog(itemIndex)"
                              class="patient-visits__diary__icon-file" />
                          </template>
                          <template v-slot:no-data>
                            <p style="padding: 10px; margin: 0">{{ noDataDisease }}</p>
                          </template>
                        </input-disease-search>
                      </div>
                    </template>
                  </form-visit-diary>
                </div>
                <phrase-library
                  class="diary-tab__phrase-library"
                  ref="diaryPhraseLibraryRef"
                  v-bind:show="hasFocusedDiaryField && !isFieldAwaitLibrary"
                  v-bind:phrases="selectedDiaryLibraryPhrases"
                  v-on:blur="onBlurDiaryLibrary"
                  v-on:input-phrase="onInputDiaryPhrase"
                  v-on:add-phrase="showCreatePhraseDialog"
                  v-on:add-group="showCreateGroupDialog"
                  v-on:remove-phrase="onRemoveDiaryPhrase"
                  v-on:edit-phrase="showCreatePhraseDialog"
                  v-on:remove-group="onRemoveDiaryGroup"
                  v-on:edit-group="showCreateGroupDialog"
                />
              </template>
            </tabs-items>
            <div v-if="restrictEditingBranchVisit" class="patient-visits__protocol__buttons">
              <the-tooltip position="top">
                <template v-slot:trigger="{ listenerObject }">
                  <button
                    disabled
                    class="patient-visits__protocol__add"
                    type="button"
                    v-on="listenerObject"
                  >
                    Добавить протокол
                  </button>
                </template>
                {{ restrictMessage }}
              </the-tooltip>
              <the-tooltip position="top">
                <template v-slot:trigger="{ listenerObject }">
                  <button
                    disabled
                    class="patient-visits__protocol__add"
                    type="button"
                    v-on="listenerObject"
                  >
                    Сохранить в шаблон
                  </button>
                </template>
                {{ restrictMessage }}
              </the-tooltip>
            </div>
            <div v-else class="patient-visits__protocol__buttons">
              <button
                v-bind:class="{ 'disable-component': restrictEditingVisit }"
                type="button"
                class="patient-visits__protocol__add"
                v-on:click="createDiary(); scrollToNewDiary()"
              >Добавить протокол</button>
              <popover-menu
                offset-y
                top
                v-bind:close-on-content-click="false"
                v-model="isShownDiaryTemplateCreateDialog"
              >
                <form class="print-visit-form" v-on:submit.prevent="createDiaryTemplate">
                  <input-text-length-limitation
                    v-bind:title="'Укажите название шаблона'"
                    v-bind:max-length="200"
                    v-model="diaryTemplateName"
                  />
                  <autocomplete-input
                    label="Категория"
                    v-bind:items="diaryTemplateCategories"
                    item-text="name"
                    item-value="id"
                    v-bind:violations="categoryErrors"
                    v-model="selectedDiaryTemplateCategory" />
                  <button
                    class="print-visit-form__button"
                    type="submit">Сохранить</button>
                </form>
                <template v-slot:trigger="{ listenerObject }">
                  <button
                    class="patient-visits__protocol__add"
                    type="button"
                    v-on="listenerObject"
                  >Сохранить в шаблон</button>
                </template>
              </popover-menu>
            </div>
          </template>
          <div class="patient-visits__protocol__files">
            <the-tooltip v-if="restrictEditingBranchVisit" position="top">
              <template v-slot:trigger="{ listenerObject }">
                <button
                  disabled
                  class="patient-visits__protocol__files__title"
                  type="button"
                  v-on="listenerObject"
                >
                  Прикрепить файлы
                </button>
              </template>
              {{ restrictMessage }}
            </the-tooltip>
            <button
              v-else
              v-bind:class="{ 'disable-component': restrictEditingVisit }"
              class="patient-visits__protocol__files__title"
              type="button"
              v-on:click="toggleProtocolFiles"
            >Прикрепить файлы {{ this.getCurrentFilesString() }}
            </button>
            <drag-and-drop-patient-files
              v-if="isShowProtocolFiles"
              hint="не более 24 Мб, файлы .pdf .doc .docx .png .jpg"
              v-bind:error-files="files.error"
              v-bind:input-files="[...files.current, ...files.uploading]"
              v-bind:violation-causes="inputErrors"
              v-bind:initial-view-mode="$options.galleryMode"
              v-on:download-file="onFileDownload"
              v-on:remove-file="onAddFileToDeleted"
              v-on:open-file="onOpenFile"
              v-on:upload-file="onAddFileToUploaded"
              v-on:click.native="onClickFileForm"
            />
          </div>
        </patient-section>
        <modal-dialog
          max-width="auto"
          scrollable
          title="Болезни полости рта, слюнных желёз и челюстей (МКБ-10)"
          v-model="showDiseasesDialog"
          with-cross
        >
          <select-item-tree-dialog
            v-bind:fetch-children="fetchDiseaseChildren"
            v-bind:items="diseaseTree"
            v-on:change="onChangeIcd"
            v-on:created="fetchDiseaseCategories"
          />
          <template v-slot:actions>
            <button
              class="patient-visits__diary__buttons__button-cancel"
              type="button"
              v-on:click="showDiseasesDialog = false"
            >Закрыть</button>
          </template>
        </modal-dialog>
        <modal-dialog
          max-width="auto"
          scrollable
          title="Шаблоны протокола приема"
          v-model="shownDiaryTemplateDialog"
          with-cross
        >
          <select-item-tree-dialog
            v-bind:fetch-children="getDiaryTemplateChildren"
            v-bind:items="diaryTemplateTree"
            v-on:change="onChangeDiaryTemplate"
            v-on:created="getDiaryTemplateCategoriesList"
          />
          <template v-slot:actions>
            <button
              class="patient-visits__diary__buttons__button-cancel"
              type="button"
              v-on:click="shownDiaryTemplateDialog = false"
            >Закрыть</button>
          </template>
        </modal-dialog>
        <modal-dialog
          title="Выберите прайс лист"
          max-width="750"
          v-model="shownPriceListsSelectModal"
          v-on:on-click-outside="shownPriceListsSelectModal = false"
          with-cross
        >
          <price-lists-select-modal
            v-bind:price-lists=serviceGroupedByPriceList
            v-on:select-price-list="onSelectedPriceList"
          />
        </modal-dialog>
        <patient-section label="Услуги" class="patient-visits__services">
          <the-tabs
            v-bind:items="invoices.rows"
            v-model="invoiceTab"
          >
            <template v-slot:default="{ item, itemIndex } ">
              <div class="patient-visits__services__tab__head">
                {{ `Счет ${itemIndex + 1}` }}
                <p
                  v-if="doctorAssistanceExists"
                  class="patient-visits__services__tab__name"
                >
                  {{ item.employee.name }}
                </p>
              </div>
              <button
                v-if="canDeleteInvoices && item.actions.includes('delete')"
                type="button"
                v-on:click.prevent.stop="onDeleteInvoice(itemIndex)"
                class="patient-visits__protocol__delete"
              />
            </template>
            <template v-slot:after-items>
              <the-tooltip v-if="restrictEditingBranchVisit" position="top">
                <template v-slot:trigger="{ listenerObject }">
                  <button
                    v-bind:disabled="restrictEditingVisit"
                    class="patient-visits__services__button tab-add"
                    type="button"
                    title="Добавить счет"
                    aria-label="Добавить счет"
                    v-on="listenerObject"
                  />
                </template>
                {{ restrictMessage }}
              </the-tooltip>
              <button
                v-else
                v-bind:disabled="restrictEditingVisit"
                class="patient-visits__services__button tab-add"
                type="button"
                title="Добавить счет"
                aria-label="Добавить счет"
                v-on:click="onCreateInvoice"
              />
            </template>
          </the-tabs>
          <tabs-items
            class="patient-visits__diary__tabs patient-visits__diary__tabs-services"
            tab-class="invoice-tab"
            is-touchless
            v-bind:items="invoices.rows"
            v-model="invoiceTab"
          >
            <template v-slot:default="{ item, itemIndex }">
              <visit-service-table
                v-on:clean-list="onCleanServiceTable(itemIndex)"
                v-bind:class="{ 'disable-component': restrictEditingVisit }"
                v-bind:can-change-discount="canChangeDiscount"
                v-bind:can-delete-positions="canDeletePositions"
                v-bind:initial-discount-type="item.discountType"
                v-bind:is-milk-bite-default="isMilkBite"
                v-bind:rows="item.serviceTable.rows"
                v-bind:violations="serviceViolations"
                v-bind:treatments-plan-template-categories="treatmentsPlanTemplateCategories"
                v-bind:patient-loyalty-card="patientLoyaltyCard"
                v-on:input-discount-type="onInputDiscountType(itemIndex, $event)"
                v-on:add="onAddingPriceService(itemIndex, $event)"
                v-on:change="onChangeService(itemIndex, ...$event)"
                v-on:delete="onDeleteService(item.id, itemIndex, $event)"
              />
              <div class="patient-visits__services__row">
                <div v-if="restrictEditingBranchVisit" class="patient-visits__services__row__adding-service">
                  <the-tooltip position="top">
                    <template v-slot:trigger="{ listenerObject }">
                      <button
                        disabled
                        class="patient-visits__services__button"
                        type="button"
                        v-on="listenerObject"
                      >
                        Добавить из прайса
                      </button>
                    </template>
                    {{ restrictMessage }}
                  </the-tooltip>
                  <the-tooltip v-if="hasTreatmentPlans" position="top">
                    <template v-slot:trigger="{ listenerObject }">
                      <button
                        disabled
                        class="patient-visits__services__button treatment-plan"
                        type="button"
                        v-on="listenerObject"
                      >
                        Добавить из плана лечения
                      </button>
                    </template>
                    {{ restrictMessage }}
                  </the-tooltip>
                </div>
                <div v-else class="patient-visits__services__row__adding-service">
                  <button
                    v-bind:class="{ 'disable-component': restrictEditingVisit }"
                    class="patient-visits__services__button"
                    type="button"
                    v-on:click="onClickServiceSelect"
                  >Добавить из прайса</button>
                  <button
                    v-bind:class="{ 'disable-component': restrictEditingVisit }"
                    v-if="hasTreatmentPlans"
                    class="patient-visits__services__button treatment-plan"
                    type="button"
                    v-on:click="onClickAddTreatmentPlanTemplate"
                  >Добавить из плана лечения</button>
                </div>
                <button
                  v-if="item.id && canViewInvoice"
                  type="button"
                  class="patient-visits__services__button invoice"
                  v-on:click="toPatientInvoice(item.id)"
                >Перейти к счету</button>
              </div>
            </template>
          </tabs-items>
        </patient-section>
        <patient-section label="Заказ-наряд" class="patient-visits__services">
          <visit-work-order-table
            v-bind:class="{ 'disable-component': restrictEditingVisit }"
            v-bind:rows="workOrderTable.rows"
            v-bind:service-options="serviceList"
            v-on:change="onChangeServiceWorkOrder"
            v-on:delete="onDeleteServiceWorkOrder"
          />
          <div class="patient-visits__services__row">
            <div class="patient-visits__services__row__adding-service">
              <the-tooltip v-if="restrictEditingBranchVisit" position="top">
                <template v-slot:trigger="{ listenerObject }">
                  <button
                    disabled
                    class="patient-visits__services__button"
                    type="button"
                    v-on="listenerObject"
                  >
                    Добавить услугу
                  </button>
                </template>
                {{ restrictMessage }}
              </the-tooltip>
              <button
                v-else
                v-bind:class="{ 'disable-component': restrictEditingVisit }"
                class="patient-visits__services__button"
                type="button"
                v-on:click="workOrderTable.addRow(); onReachAddServiceGoal();"
              >Добавить услугу</button>
            </div>
          </div>
        </patient-section>
        <patient-section
          label="ЕГИСЗ"
          v-if="canCheckCdaFields && canViewCdaFields"
        >
          <div class="patient-visits__diary" v-bind:class="{ 'disable-component': restrictEditingVisit }">
            <the-select
              placeholder="Выберите степень тяжести при поступлении"
              title="Состояние пациента"
              v-bind:optional="false"
              v-bind:options="nsiConditionSeverenities"
              v-bind:violations="inputNsiConditionSeverenityErrors"
              v-model="visit.nsiConditionSeverenity"
            />
            <textarea-length-limitation
              placeholder="Жалоб нет. Проведена профессиональная чистка зубов и даны рекомендации по ежедневной гигиене."
              rows="4"
              show-counter
              title="Заключение"
              class="patient-visits__textarea"
              v-bind:max-length="1000"
              v-bind:optional="false"
              v-bind:violations="inputOcclusionErrors"
              v-model="visit.occlusion"
            />
            <the-select
              placeholder="Выберите источник оплаты медицинской помощи"
              title="Источник оплаты медицинской помощи"
              v-bind:optional="false"
              v-bind:options="nsiMedicalCarePaymentSourcesForVisit"
              v-bind:violations="inputNsiMedicalCarePaymentSourceErrors"
              v-model="visit.nsiMedicalCarePaymentSource"
            />
          </div>
        </patient-section>
        <p
          class="patient-visits__refund-egisz-title"
          v-else-if="canViewCdaFields"
        >
          Пациент отказался от передачи данных в ЕГИСЗ
        </p>
        <div class="patient-visits__buttons">
          <the-tooltip v-if="restrictEditingBranchVisit" position="top">
            <template v-slot:trigger="{ listenerObject }">
              <button
                disabled
                class="patient-visits__button-save"
                type="button"
                v-on="listenerObject"
              >
                Сохранить
              </button>
            </template>
            {{ restrictMessage }}
          </the-tooltip>
          <button
            v-else
            v-bind:class="{ 'disable-component': restrictEditingVisit }"
            class="patient-visits__button-save"
            type="submit"
            v-bind:disabled="isDisableSave"
            v-on:click="onSaveVisit"
          >Сохранить</button>
          <the-tooltip v-if="canCheckCdaFields && restrictEditingBranchVisit" position="top">
            <template v-slot:trigger="{ listenerObject }">
              <button
                disabled
                class="patient-visits__button-egisz-save"
                type="button"
                v-on="listenerObject"
              >
                Сохранить и отправить в ЕГИСЗ
              </button>
            </template>
            {{ restrictMessage }}
          </the-tooltip>
          <button
            v-bind:class="{ 'disable-component': restrictEditingVisit }"
            class="patient-visits__button-egisz-save"
            type="submit"
            v-else-if="canCheckCdaFields"
            v-bind:disabled="isDisableSave"
            v-on:click="onSaveVisitAndFormingEgiszDraft"
          >Сохранить и отправить в ЕГИСЗ</button>
          <popover-menu
            offset-y
            top
            v-bind:close-on-content-click="false"
            v-model="isShownPrintDocumentsDialog"
          >
            <div class="print-visit-form">
              <div
                class="print-visit-form__document print-visit-form__document--print"
                v-for="document in printDocumentList"
                v-bind:key="document.id"
              >
                <span>{{ document.name }}</span>
                <label
                  v-if="document.id !== $options.documentForm058uId"
                  class="print-visit-form__document__count">
                  <input
                    aria-label="Выбор количества копий"
                    type="number"
                    v-bind:min="0"
                    v-mask="`##`"
                    v-model="document.count"
                    v-on:change="onDocumentCopyCountChanged(document, $event)"
                  />
                  <span>экз.</span>
                </label>
                <div v-if="document.id === 'protocol'" class="print-visit-form__document__format">
                  <label>
                    <input type="radio" value="A4" v-model="document.format">
                    A4
                  </label>
                  <label>
                    <input type="radio" value="A5" v-model="document.format">
                    A5
                  </label>
                </div>
                <button
                  class="print-visit-form__document__button-print"
                  type="button"
                  v-on:click="onPrintDocument(document)" />
              </div>
            </div>
            <template v-slot:trigger="{ listenerObject }">
              <button
                v-if="!isMobile"
                class="patient-visits__visit__button-print"
                type="button"
                v-on="listenerObject"
              >Печать</button>
            </template>
          </popover-menu>
          <popover-menu
            offset-y
            top
            v-bind:close-on-content-click="false"
            v-model="isShownDownloadDocumentsDialog"
          >
            <form
              class="print-visit-form"
              v-on:submit.prevent="onDownloadDocument"
            >
              <div
                class="print-visit-form__document"
                v-for="document in downloadDocumentList"
                v-bind:key="document.id"
              >
                <input-checkbox
                  v-bind:title="document.name"
                  v-model="document.isPrint"
                />
                <label v-if="document.id === 'act'" class="print-visit-form__document__count">
                  <span> № </span>
                  <input
                    aria-label="Ввод номера"
                    type="number"
                    v-bind:min="1"
                    v-model="document.number"
                  />
                </label>
                <div v-if="document.id === 'act'" class="print-visit-form__document__date">
                  <span>от</span>
                  <input
                    type="date"
                    v-model="document.date"
                  />
                </div>
              </div>
              <button
                v-if="!isMobile"
                type="submit"
                class="print-visit-form__button"
              >Скачать</button>
            </form>
            <template v-slot:trigger="{ listenerObject }">
              <button
                v-if="!isMobile"
                class="patient-visits__visit__button-download"
                type="button"
                v-on="listenerObject"
              >Скачать</button>
            </template>
          </popover-menu>
        </div>
      </patient-section-control>
    </form>
    <form
      v-if="!isNewVisit"
      class="patient-visits__form-notes"
      v-on:submit.prevent="onAddVisitNote"
    >
      <h3>
        Заметки к визиту
        <span
          v-if="unreadNotesCount > 0"
          class="patient-visits__notes-count"
        >({{ unreadNotesCount }})</span>
      </h3>
      <textarea-length-limitation
        v-bind:class="{ 'disable-component': restrictEditingVisit }"
        placeholder="Введите текст"
        rows="4"
        v-bind:max-length="1000"
        v-model="visitNote"
        v-bind:violations="inputVisitNoteTextErrors"
      />
      <button
        class="patient-visits__visit__button-download"
        type="submit"
      >Добавить</button>
      <div class="patient-visits__notes">
        <div
          v-for="note in visibleVisitNotes"
          v-bind:key="note.id"
          class="patient-visits__note"
          v-bind:class="{ new: note.isNew }"
        >
          <div class="patient-visits__note__header">
            <div class="patient-visits__note__actions" v-if="note.canEdit">
              <button
                type="button"
                class="patient-visits__note__action edit"
                v-if="!note.isEditing"
                v-on:click="note.isEditing = true"
                title="Редактировать"
              />
              <button
                type="button"
                class="patient-visits__note__action delete"
                v-if="!note.isEditing"
                v-on:click="onRemoveVisitNote(note.id)"
                title="Удалить"
              />
            </div>
          </div>
          <div class="patient-visits__note__content">
            <template v-if="note.isEditing">
              <textarea-length-limitation
                rows="2"
                v-bind:max-length="1000"
                v-model="note.editingText"
              />
              <div class="patient-visits__note__edit-buttons">
                <button
                  type="button"
                  class="patient-visits__note__button-save"
                  v-on:click="onEditVisitNote(note)"
                >Сохранить</button>
                <button
                  type="button"
                  class="patient-visits__note__button-cancel"
                  v-on:click="note.isEditing = false; note.editingText = note.text"
                >Отмена</button>
              </div>
            </template>
            <p v-else>{{ note.text }}</p>
          </div>
          <div class="patient-visits__note__info">
            <span class="patient-visits__note__author">{{ note.author }}</span>
            <span class="patient-visits__note__date">{{ note.date }}</span>
          </div>
        </div>
        <button
          v-if="visitNoteList.length > 5 && !showAllNotes"
          type="button"
          class="patient-visits__notes__show-more"
          v-on:click="showAllNotes = true"
        >
          Показать еще
        </button>
      </div>
    </form>
  </patient-profile>
</template>

<script>
import { List, Maybe, Validation } from 'monet';
import addingServicesFromPriceMixin from '@/mixins/addingServicesFromPriceMixin';
import dateMixin from '@/mixins/dateMixin';
import notifierMixin from '@/mixins/notifierMixin';
import DentalFormula from '@/components/DentalFormula.vue';
import DragAndDropPatientFiles from '@/components/DragAndDropPatientFiles.vue';
import PatientSection, { PatientSectionControl } from '@/components/PatientSection.vue';
import PopoverMenu from '@/components/PopoverMenu.vue';
import TextareaLengthLimitation from '@/components/TextareaLengthLimitation.vue';
import TextareaView from '@/components/TextareaView.vue';
import VisitServiceTable from '@/components/VisitServiceTable.vue';
import {
  CreateVisitDiaryRequest,
  CreateVisitRequest,
  CrmDealOptions,
  DentalCavities,
  Diary,
  DiaryTemplateCreationRequest,
  DownloadDocumentRequest,
  EditPatientDentalCavitiesRequest,
  EditPatientVisitRequest,
  EditVisitDiaryRequest,
  Invoices,
  PatientVisit,
  PositionDiscount,
  PrintDocumentsRequest,
  ServiceTable,
  VisitInvoice,
  VisitPosition,
  VisitPositionFromTreatmentPlan,
  WorkOrderRow,
  WorkOrderTable,
} from '@/storage/gateways/VisitGateway';
import { builtInDialogMixin, DialogResult } from '@/components/ClinicPanelDialog.vue';
import SelectItemTreeDialog from '@/components/SelectItemTreeDialog.vue';
import { popoverMixin } from '@/mixins/builtInPopoverMixin';
import ModalDialogPreventLeave from '@/components/ModalDialogPreventLeave.vue';
import preventLeaveWithoutConfirmMixin from '@/mixins/preventLeaveWithoutConfirmMixin';
import TheCarousel from '@/components/TheCarousel.vue';
import CollapseButton from '@/components/CollapseButton.vue';
import CollapseField from '@/components/CollapseField.vue';
import debounce from 'lodash.debounce';
import InputCheckbox from '@/components/InputCheckbox.vue';
import TheSelect from '@/components/TheSelect.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import {
  DISCOUNT_IN_KOPECK,
  DISCOUNT_IN_PERCENT,
  DISCOUNT_MIXED,
} from '@/components/SwitchDiscountType.vue';
import set from 'lodash.set';
import PickerServices from '@/components/PickerServices.vue';
import MatchedServiceList from '@/components/MatchedServiceList.vue';
import TheTabs from '@/components/TheTabs.vue';
import TabsItems from '@/components/TabsItems.vue';
import InputDiseaseSearch from '@/components/InputDiseaseSearch.vue';
import InputTextSearch from '@/components/InputTextSearch.vue';
import PatientProfile from '@/views/ClinicPanel/PatientProfile.vue';
import InputTextLengthLimitation from '@/components/InputTextLengthLimitation.vue';
import VisitWorkOrderTable from '@/components/VisitWorkOrderTable.vue';
import TeethSelectPopup from '@/components/TeethSelectPopup.vue';
import TeethGroupMixin from '@/mixins/teethGroupMixin';
import mobileMixin from '@/mixins/mobileMixin';
import mobilePopupMixin from '@/mixins/mobilePopupMixin';
import MobileFixedBottomPopup from '@/components/MobileFixedBottomPopup.vue';
import SearchInput from '@/components/SearchInput.vue';
import OralExamination from '@/components/OralExamination.vue';
import TheRub from '@/components/TheRub.vue';
import PriceListsSelectModal from '@/components/PriceListsSelectModal.vue';
import PhraseLibrary from '@/components/PhraseLibrary.vue';
import AutocompleteInput from '@/components/AutocompleteInput.vue';
import InputAutocomplete from '@/components/InputAutocomplete.vue';
import diseaseMixin from '@/mixins/diseaseMixin';
import TheTooltip from '@/components/TheTooltip.vue';
import { GALLERY_MODE } from '@/components/SwitchViewMode.vue';
import {
  GOAL_ADD_INVOICE,
  GOAL_ADD_SERVICES_TO_CUSTOM_ORDER_PATIENT_VISITS,
  GOAL_ADDING_TREATMENT_PLAN_SERVICE,
  GOAL_APPLY_DIARY_TEMPLATE,
  GOAL_ATTACH_FILE_PATIENT_VISITS,
  GOAL_DOWNLOAD_DOCUMENT_PROTOCOL,
  GOAL_PRINT_043Y_PATIENT_VISITS,
  GOAL_PRINT_DOCUMENT_PROTOCOL,
  GOAL_SAVE_PROTOCOL_AS_TEMPLATE_PATIENT_VISITS,
  GOAL_SELECT_TEETH_DIARY,
  GOAL_SWITCH_DETAIL_DENTAL_FORMULA,
  GOAL_TO_ANOTHER_VISIT_PATIENT_VISITS,
  GOAL_TO_INVOICE_PATIENT_VISITS,
} from '@/plugins/metric';
import metricMixin from '@/mixins/metricMixin';

/**
 * @description Ключи ошибок секции "ЕГИСЗ".
 * @type {string[]}
 */
const EGISZ_SECTION_ERROR_FIELD_KEYS = [
  'visit.occlusion',
  'visit.nsi-condition-severenity',
  'visit.nsi-medical-care-payment-source',
];

/**
 * @description Индекс секции "ЕГИСЗ".
 * @type {number}
 */
const EGISZ_SECTION_INDEX = 4;

/**
* @description Ключи ошибок секции "Протоколы приема".
* @type {string[]}
*/
const DIARY_SECTION_ERROR_FIELD_KEYS = [
  'diary.teeth',
  'anamnesis.diagnosis',
  'diary.complaints',
  'diary.disease',
  'anamnesis.dental-anamnesis',
  'anamnesis.guarantees',
  'anamnesis.objectively',
  'anamnesis.recommendations',
  'anamnesis.studies',
  'anamnesis.treatment',
];

/**
 * @description Условные обозначения.
 * @type {{name:string, description:string}[]}
 */
const diagnosisLegends = [
  { name: '0', description: 'отсутствует' },
  { name: 'П', description: 'пломбированный' },
  { name: 'R', description: 'корень' },
  { name: 'А', description: 'пародонтоз' },
  { name: 'C', description: 'кариес' },
  { name: 'К', description: 'коронка' },
  { name: 'P', description: 'пульпит' },
  { name: 'I,II,III', description: 'степень подвижности' },
  { name: 'Pt', description: 'периодонтит' },
  { name: 'И', description: 'искусственный зуб' },
  { name: 'Кл', description: 'клиновидный дефект' },
  { name: 'ПС', description: 'пломба/кариес' },
  { name: 'Д', description: 'дефект' },
];

/**
 * @description Список диагнозов.
 * @type {{name:string, description:string}[]}
 */
const diagnosisList = [
  { name: '', description: 'выберите значение' },
  { name: '0', description: '0 - отсутствует' },
  { name: 'П', description: 'П - пломбированный' },
  { name: 'R', description: 'R - корень' },
  { name: 'А', description: 'А - пародонтоз' },
  { name: 'C', description: 'C - кариес' },
  { name: 'К', description: 'К - коронка' },
  { name: 'P', description: 'P - пульпит' },
  { name: 'I', description: 'I степень подвижности' },
  { name: 'II', description: 'II степень подвижности' },
  { name: 'III', description: 'III степень подвижности' },
  { name: 'Pt', description: 'Pt - периодонтит' },
  { name: 'И', description: 'И - искусственный зуб' },
  { name: 'Кл', description: 'Кл - клиновидный дефект' },
  { name: 'ПС', description: 'ПС - пломба/кариес' },
  { name: 'Д', description: 'Д - дефект' },
];

/**
 * @description Индекс секции "Протоколы приема"
 * @type {number}
 */
const DIARY_SECTION_INDEX = 1;

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Сохранить файл.
 * @param {any}    file Файл.
 * @param {string} name Название файла.
 */
function saveFile(file, name) {
  const obj = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = obj;
  link.target = '_blank';
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
  link.remove();
}

/**
 * @description Примесь добавления услуг из планов лечения.
 * @type {Vue}
 */
const addingServicesFromTreatmentPlansMixin = {
  galleryMode: GALLERY_MODE,
  computed: {
    /**
     * @description Наличие планов лечения.
     * @type {boolean}
     */
    hasTreatmentPlans() {
      return this.treatmentPlanList.length > 0;
    },
  },
  data() {
    return {
      /**
       * @description Показывать модальное окно добавление услуг из планов лечения.
       * @type {Array}
       */
      shownAddingServicesFromTreatmentPlansModal: false,
      /**
       * @description Список планов лечения.
       * @type {Array}
       */
      treatmentPlanList: [],
    };
  },
  methods: {
    /**
     * @description Обработать события печати зубной формулы визита
     *
     * @returns {void}
     */
    onPrintVisitFormulaTeeth() {
      const onSuccess = (response) => {
        const blob = new Blob([response], { type: 'text/html' });
        const container = this.$refs.printView;
        container.setAttribute('src', URL.createObjectURL(blob));
        container.onload = () => {
          container.contentWindow.print();
          this.isShownPrintDocumentsDialog = false;
        };
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$visitGateway
        .viewVisitFormulaTeethPrint(
          this.selectedVisitId,
          this.isMilkBite,
        )
        .then((result) => {
          result.fold(onFail, onSuccess);
        });
    },
    /**
     * @description Получить суммарную стоимость выбранных услуг.
     * @param {ServiceSelectedList} selectedServices Выбранные услуги.
     * @returns {number}
     */
    getSelectedTreatmentPlanServicesAmount(selectedServices) {
      return selectedServices
        .toArray()
        .reduce((amount, service) => {
          if (service.byVHIPolicy || service.complaint) { return amount; }
          return amount + Math.round(service.cost * service.count);
        }, 0);
    },
    /**
     * @description Обработать добавление услуг плана лечения в услуги визита.
     * @returns {void}
     */
    onSubmitAddingTreatmentPlanServices(selectedServices) {
      const setDiscount = (service) => {
        if (this.discountType === service.discount.getType()) {
          return service;
        }
        const discount = this.discountType === DISCOUNT_IN_KOPECK
          ? service.discount.convertToKop(service.amount.toKop())
          : service.discount.convertToPercent(service.amount.toKop());
        return service.setDiscount(discount);
      };
      const items = selectedServices.map(
        (service, index) => {
          const treatmentPlanService = new VisitPositionFromTreatmentPlan(
            service.byVHIPolicy,
            service.categoryName,
            service.count,
            false,
            service.dentalParts.slice(),
            new PositionDiscount(service.discountType, service.discount),
            0,
            service.id,
            service.cost,
            service.serviceId,
            service.name,
            service.teeth.slice(),
            service.units,
            `tp-${service.id}-${index}-${Date.now()}`,
          );
          return setDiscount(treatmentPlanService);
        },
      );
      this.addServicesToInvoiceServiceTable(this.invoiceTab, items);
      this.shownAddingServicesFromTreatmentPlansModal = false;
    },
    onAddingTreatmentPlanService(selectedService) {
      const { discountType } = this.invoices.rows[this.invoiceTab];
      const setDiscount = (service) => {
        if (discountType === service.discount.getType()) {
          return service;
        }
        const discount = discountType === DISCOUNT_IN_KOPECK
          ? service.discount.convertToKop(service.amount.toKop())
          : service.discount.convertToPercent(service.amount.toKop());
        return service.setDiscount(discount);
      };
      const treatmentPlanService = new VisitPositionFromTreatmentPlan(
        selectedService.byVHIPolicy,
        selectedService.categoryName,
        selectedService.count,
        false,
        selectedService.dentalParts.slice(),
        new PositionDiscount(selectedService.discountType, selectedService.discount),
        0,
        selectedService.id,
        selectedService.cost,
        selectedService.serviceId,
        selectedService.name,
        selectedService.teeth.slice(),
        selectedService.units,
        `tp-${selectedService.id}-${Date.now()}`,
      );
      const index = this.invoices.rows[this.invoiceTab].serviceTable.rows.findIndex(
        (item) => item.serviceId === selectedService.serviceId,
      );
      if (index !== -1) {
        if (!this.invoices.rows[this.invoiceTab].serviceTable.rows[index].id) {
          this.invoices.rows[this.invoiceTab].serviceTable.rows.splice(index, 1);
        }
      } else {
        this.addServicesToInvoiceServiceTable(
          this.invoiceTab,
          [setDiscount(treatmentPlanService)],
        );
      }
    },
  },
};

/**
 * @description Примесь для статуса отчетности в ИЭМК ЕГИСЗ.
 * @type {Vue}
 */
const iemkMixin = {
  computed: {
    /**
     * @description Необходимо показать статус отчетности.
     * @returns {boolean}
     */
    needShowIemkStatus() {
      return false;
    },
  },
  data() {
    return {
      /**
       * @description Эпикриз.
       * @type {string}
       */
      occlusion: '',
      /**
       * @description Код статуса отчетности в ИЭМК ЕГИСЗ.
       * @type {string}
       */
      iemkStatus: '',
      /**
       * @description Пояснение статуса отчетности в ИЭМК ЕГИСЗ.
       * @type {string}
       */
      iemkStatusDescription: '',
      /**
       * @description Степени тяжести состояния по ЕГИСЗ НСИ.
       * @type {object[]}
       */
      nsiConditionSeverenities: [],
      /**
       * @description Источники оплаты медицинской помощи по ЕГИСЗ НСИ.
       * @type {object[]}
       */
      nsiMedicalCarePaymentSources: [],
    };
  },
  methods: {
    /**
     * @description Установить заполнители для ИЭМК.
     * @param {object} data Данные.
     * @returns {void}
     */
    setIemkFillers(data) {
      const {
        nsiConditionSeverenities,
        nsiMedicalCarePaymentSources,
      } = data;
      this.nsiConditionSeverenities = nsiConditionSeverenities;
      this.nsiMedicalCarePaymentSources = nsiMedicalCarePaymentSources;
    },
    /**
     * @description Установить данные просмотра визита для ИЭМК.
     * @param {object} data Данные.
     * @returns {void}
     */
    setIemkViewData(data) {
      const { iemkStatus } = data;
      this.iemkStatus = iemkStatus.getId();
      this.iemkStatusDescription = iemkStatus.getText();
    },
  },
};

/**
 * @description Локальная примесь счетов.
 * @type {any}
 */
const invoiceLocalMixin = {
  computed: {
    /**
     * @description Текст при наведении на кнопку выставления счета.
     * @type {string}
     */
    createInvoiceButtonTitle() {
      return this.isDisabledCreateInvoiceButton ? 'Сначала сохраните визит' : '';
    },
    /**
     * @description Деактивировать кнопку выставления счета.
     * @type {boolean}
     */
    isDisabledCreateInvoiceButton() {
      return this.visitIsChanged || this.invoicesIsChanged || this.isAwaitInvoiceCreate;
    },
    canDeleteInvoices() {
      return this.invoices.rows.length > 1;
    },
  },
  data() {
    return {
      invoiceActions: [],
      /**
       * @description Идентификатор счета связанного с визитом.
       * @type {?number}
       */
      invoiceId: null,
      /**
       * @description Ожидание создания счета.
       * @type {boolean}
       */
      isAwaitInvoiceCreate: false,
      /**
       * @description Индекс выбранной вкладки со счетом.
       * @type {number}
       */
      invoiceTab: null,
    };
  },
  methods: {
    /**
     * @description Обработать удаление счет.
     * @param {number} invoiceIndex
     * @returns {void}
     */
    async onDeleteInvoice(invoiceIndex) {
      if (this.isAwaitRequest) {
        return;
      }
      const dialog = await this.showRemoveDialog('Вы действительно хотите удалить счет?');
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      const invoice = this.invoices.rows[invoiceIndex];
      if (!invoice.id) {
        this.invoices.rows.splice(invoiceIndex, 1);
        this.invoiceTab = 0;
        this.checkInvoiceServicesChanged();
        return;
      }
      this.isAwaitRequest = true;
      const onSuccess = (response) => {
        this.notifySuccess(response.message);
        this.invoices.rows = this.invoices.rows.filter((candidate) => candidate !== invoice);
        this.invoiceTab = 0;
      };
      this
        .$invoiceGateway
        .deleteById(invoice.id)
        .then((result) => result.fold(this.notifyFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать создания счета.
     * @returns {void}
     */
    onCreateInvoice() {
      this.invoices.rows.push(new VisitInvoice(this.visit.getDoctor()));
      this.invoiceTab = this.invoices.rows.length - 1;
      this.checkInvoiceServicesChanged();
      this.$goal(GOAL_ADD_INVOICE);
    },
    /**
     * @description Получить навигацию до счета.
     * @returns {{name:string,params:any}}
     */
    getNavigationToInvoice(invoiceId) {
      const params = { id: this.patientId, invoiceId };
      return { name: 'ClinicPanelPatientInvoice', params };
    },
  },
};

/**
 * @description Идентификатор документа протокола.
 * @type {string}
 */
const DOCUMENT_PROTOCOL_ID = 'protocol';

/**
 * @description Идентификатор документа формы 043u.
 * @type {string}
 */
const DOCUMENT_043_ID = 'form043y';

/**
 * @description Идентификатор документа формы 058u.
 * @type {string}
 */
const DOCUMENT_058_ID = 'form058u';

/**
 * @description Локальная примесь печати документов.
 * @type {any}
 */
const printDocumentsLocalMixin = {
  documentForm043uId: DOCUMENT_043_ID,
  documentForm058uId: DOCUMENT_058_ID,
  computed: {
    diaryForPrint() {
      return this
        .diaries
        .filter((diary) => !!diary.id)
        .map((diary, index) => ({
          id: diary.id,
          name: `Протокол ${index + 1}`,
          selected: this.selectedDiariesForPrint.includes(diary.id),
        }));
    },
  },
  data() {
    return {
      /**
       * @description Выбранные протоколы приема для печати.
       * @type {number[]}
       */
      selectedDiariesForPrint: [],
      /**
       * @description Показывать диалог печати документов.
       * @type {boolean}
       */
      isShownPrintDocumentsDialog: false,
      /**
       * @description Показывать диалог печати документов.
       * @type {boolean}
       */
      isShownDownloadDocumentsDialog: false,
      /**
       * @description Показывать диалог печати документов.
       * @type {boolean}
       */
      isShownPrintDiaryDocumentsDialog: false,
      /**
       * @description Показывать диалог создания шаблона.
       * @type {boolean}
       */
      isShownDiaryTemplateCreateDialog: false,
      /**
       * @description Название шаблона.
       * @type {string}
       */
      diaryTemplateName: '',
      /**
       * @description Список документов для печати.
       * @type {any[]}
       */
      printDocumentList: [],
      /**
       * @description Список документов для загрузки.
       * @type {any[]}
       */
      downloadDocumentList: [],
    };
  },
  methods: {
    /**
     * @description Обработать изменение количества копий документа.
     * @param {any} document Документ.
     * @param {any} event    Событие.
     * @returns {void}
     */
    onDocumentCopyCountChanged(document, event) {
      const newCount = event.target.value;
      const isPrint = newCount > 0;
      Object.assign(document, { isPrint });
    },
    /**
     * @description Обработать печать документов.
     * @returns {void}
     */
    onPrintDocument(document) {
      if (document.id === DOCUMENT_043_ID) {
        this.printMedcard();
        return;
      }
      const request = new PrintDocumentsRequest(this.selectedVisitId, [document]);
      if (document.length === 0) {
        this.isShownPrintDocumentsDialog = false;
        return;
      }
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (response) => {
        const blob = new Blob([response], { type: 'text/html' });
        const container = this.$refs.printView;
        container.setAttribute('src', URL.createObjectURL(blob));
        container.onload = () => {
          container.contentWindow.print();
          this.isShownPrintDocumentsDialog = false;
        };
      };
      this
        .$visitGateway
        .viewDocumentsForPrint(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          if (document.id === DOCUMENT_PROTOCOL_ID) {
            this.$goal(GOAL_PRINT_DOCUMENT_PROTOCOL);
          }
        });
    },
    /**
     * @description Распечатать медкарту.
     * @returns {void}
     */
    printMedcard() {
      const onSuccess = (response) => {
        const container = this.$refs.printView;
        container.setAttribute('src', URL.createObjectURL(response));
        container.onload = () => {
          container.contentWindow.print();
        };
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      this
        .$patientGateway
        .viewMedcardForPrint(this.patientId, 'A4', '043u')
        .then((result) => {
          result.fold(onFail, onSuccess);
        }).finally(() => {
          this.isShownPrintDocumentsDialog = false;
        });
      this.reachPrint043YDocumentGoal();
    },
    /**
     * @description  Достичь цели - напечатать форма 043/у
     */
    reachPrint043YDocumentGoal() {
      this.reachGoalIfNotReach(GOAL_PRINT_043Y_PATIENT_VISITS);
    },
    /**
     * @description Обработать печать документов.
     * @returns {void}
     */
    onDownloadDocument() {
      const documents = this
        .downloadDocumentList
        .filter((item) => item.isPrint);
      const onSuccess = (response) => {
        const fileName = documents.length === 1 ? `${documents[0].name}.docx` : 'Документы.zip';
        saveFile(response, fileName);
        this.isShownDownloadDocumentsDialog = false;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      if (documents.length === 0) {
        this.isShownDownloadDocumentsDialog = false;
        return;
      }
      const request = new DownloadDocumentRequest(this.selectedVisitId, documents);
      this
        .$visitGateway
        .viewDocumentsForDownload(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => {
          if (documents.some(({ id }) => id === DOCUMENT_PROTOCOL_ID)) {
            this.$goal(GOAL_DOWNLOAD_DOCUMENT_PROTOCOL);
          }
        });
    },
  },
};

const BITE_OPTIONS = [
  { title: 'Временный', value: 'milk' },
  // { title: 'Смешанный', value: 'mixed' },
  { title: 'Постоянный', value: 'permanent' },
];

/**
 * @description Примесь зубной формулы.
 * @type {Vue}
 */
const dentalFormulaMixin = {
  biteOptions: BITE_OPTIONS,
  computed: {
    /**
     * @description Зубная формула по умолчанию.
     * @type {Tooth[]}
     */
    defaultDentalFormula() {
      return this.dentalFormula.orLazy(this.fetchDefaultDentalFormula);
    },
    /**
     * @description Зубы.
     * @type {Object}
     */
    teeth() {
      const partMapper = (part) => ({
        id: part.id,
        diagnoses: part.diagnoses.map((diagnosis) => diagnosis.id),
      });
      return Object.keys(this.dentalFormulaTeeth).map((number) => {
        const tooth = this.dentalFormulaTeeth[number];
        const parts = tooth.parts.map(partMapper);
        return { number, parts };
      }, {});
    },
    /**
     * @description Зубная формула в виде строки.
     * @type {string}
     */
    dentalFormulaAsString() {
      return JSON.stringify(this.teeth);
    },
    /**
     * @description Зубная формула изменена.
     * @type {boolean}
     */
    dentalFormulaIsChanged() {
      const isBiteChanged = this.initialBiteMode !== this.biteMode;
      const isFormulaTypeChanged = this.isDetailedDentalFormula
        !== this.initialIsDetailedDentalFormula;
      return this.dentalFormulaTeethIsChanged || isBiteChanged || isFormulaTypeChanged;
    },
    /**
     * @description Зубная полость изменена.
     * @type {boolean}
     */
    dentalCavitiesIsChanged() {
      return this.dentalCavities.isChanged();
    },
    /**
     * @description Зубы полости рта.
     * @type {any[]}
     */
    teethDentalCavities({ dentalCavities, biteMode }) {
      if (!dentalCavities) {
        return [];
      }
      return biteMode === 'milk'
        ? dentalCavities.teeth.slice(32, dentalCavities.teeth.length)
        : dentalCavities.teeth.slice(0, 32);
    },
    isMilkBite() {
      return this.biteMode === 'milk';
    },
  },
  data() {
    return {
      /**
       * @description Начальное значение прикуса.
       * @type {string}
       */
      initialBiteMode: 'permanent',
      /**
       * @description Прикус.
       * @type {string}
       */
      biteMode: 'permanent',
      /**
       * @description Зубная формула.
       * @type {Maybe}
       */
      dentalFormula: Maybe.none(),
      /**
       * @description Диагнозы зубной формулы.
       * @type {Object.<string,Diagnosis>}
       */
      dentalFormulaDiagnoses: {},
      /**
       * @description Зубы зубной формулы.
       * @type {Object.<number,Tooth>}
       */
      dentalFormulaTeeth: {},
      /**
       * @description Детальная формула полости рта.
       * @type {boolean}
       */
      isDetailedDentalFormula: true,
      /**
       * @description Начальное значение детальной формулы полости рта.
       * @type {boolean}
       */
      initialIsDetailedDentalFormula: true,
      /**
       * @description Начальное значение зубной формулы в виде строки.
       * @type {string}
       */
      initialDentalFormulaAsString: '',
      /**
       * @description Зубная формула изменена.
       * @type {boolean}
       */
      dentalFormulaTeethIsChanged: false,
      /**
       * @description Полость рта.
       * @type {DentalCavities}
       */
      dentalCavities: new DentalCavities(),
    };
  },
  diagnosisLegends,
  diagnosisList,
  methods: {
    /**
     * @description Отправить запрос на редактирование зубной формулы.
     * @returns {Promise<Validation>}
     */
    sendDentalFormulaEditRequest() {
      const onSuccess = () => {
        this.initialDentalFormulaAsString = this.dentalFormulaAsString;
        this.dentalFormulaTeethIsChanged = false;
        this.initialBiteMode = this.biteMode;
        this.initialIsDetailedDentalFormula = this.isDetailedDentalFormula;
      };
      const response = this
        .$visitGateway
        .editDentalFormula(
          this.selectedVisitId,
          this.teeth,
          this.biteMode,
          this.isDetailedDentalFormula,
        );
      response.then((result) => result.forEach(onSuccess));
      return response;
    },
    /**
     * @description Отправить запрос на изменение ротовой полости.
     * @returns {Promise<Validation>}
     */
    sendDentalCavitiesEditRequest() {
      const request = new EditPatientDentalCavitiesRequest(
        this.dentalCavities,
        this.selectedVisitId,
      );
      const onSuccess = () => {
        this.dentalCavities.refresh();
      };
      const response = this.$visitGateway.editDentalCavities(request);
      response.then((result) => result.forEach(onSuccess));
      return response;
    },
    /**
     * @description Обработать изменение диагнозов зубов.
     * @param {Object.<number,Object>} teeth Зубы.
     * @returns {void}
     */
    onChangeTeeth(teeth) {
      const setDiagnoses = (toothNumber, part) => {
        const tooth = this.dentalFormulaTeeth[toothNumber];
        const partCandidate = tooth.parts.find((candidate) => candidate.id === part.id);
        if (partCandidate) {
          const partDiagnoses = this.dentalFormulaDiagnoses[part.id];
          partCandidate.diagnoses = part.diagnoses.map((diagnosisId) => partDiagnoses
            .find((candidate) => candidate.id === diagnosisId));
        }
      };
      Object.keys(teeth).forEach((number) => {
        teeth[number].forEach((part) => setDiagnoses(number, part));
      });
    },
    /**
     * @description Обработать изменение зуба.
     */
    onToothChange(toothNumber, { part, value }) {
      const tooth = this.dentalCavities.teeth.find((item) => item.number === toothNumber);
      tooth[part] = value;
    },
    /**
     * @description Обработать изменение диагнозов зуба.
     * @param {number} toothNumber Номер зуба.
     * @param {Part[]} parts       Части зуба.
     * @returns {void}
     */
    onChangeToothDiagnoses(toothNumber, parts) {
      const tooth = this.dentalFormulaTeeth[toothNumber];
      parts.forEach((part) => {
        const partIndex = tooth.parts.findIndex((candidate) => candidate.id === part.id);
        this.$set(tooth.parts, partIndex, part);
      });
    },
    /**
     * @description Обработать изменение диагнозов части зуба.
     * @param {number}   toothNumber Номер зуба.
     * @param {Part}     part        Часть зуба.
     * @returns {void}
     */
    onChangeToothPartDiagnoses(toothNumber, part) {
      const tooth = this.dentalFormulaTeeth[toothNumber];
      const partIndex = tooth.parts.findIndex((candidate) => candidate.id === part.id);
      this.$set(tooth.parts, partIndex, part);
    },
    /**
     * @description Получить зубную формулу.
     * @returns {Tooth[]}
     */
    fetchDefaultDentalFormula() {
      const onResponse = (result) => {
        result.forEach((dentalFormula) => {
          this.dentalFormula = Maybe.Some(dentalFormula);
          this.dentalFormulaTeeth = this.defaultDentalFormula.make();
        });
        result.forEachFail(({ title }) => {
          this.notifyFail(title);
        });
      };
      this.$visitGateway.patientLastDentalFormula(this.patientId).then(onResponse);
      return { make: () => ({}) };
    },
    /**
     * @description Обработать переключение детальной зубной формулы.
     * @returns {void}
     */
    onSwitchDetailDentalFormula() {
      this.$goal(GOAL_SWITCH_DETAIL_DENTAL_FORMULA);
    },
  },
  watch: {
    dentalFormulaAsString(value) {
      const isChanged = value !== this.initialDentalFormulaAsString;
      this.dentalFormulaTeethIsChanged = isChanged;
    },
  },
};

/**
 * @description Примесь библиотеки фраз протокола приема.
 * @type {Vue}
 */
const diaryLibraryMixin = {
  computed: {
    /**
     * @description Свойство поля протокола приема по ключу поля в фокусе.
     * @type {Maybe<string>}
     */
    focusedDiaryFieldProperty() {
      return this
        .focusedDiaryField
        .bind((key) => Maybe.fromEmpty(this.$options.resolveDiaryFieldProperty(key)));
    },
    /**
     * @description Имеет поле протокола приема в фокусе.
     * @type {boolean}
     */
    hasFocusedDiaryField() {
      return this.focusedDiaryField.isSome();
    },
    /**
     * @description Выбранная библиотека протокола приема.
     * @type {Maybe<object>}
     */
    selectedDiaryLibrary() {
      const findPhrasesByField = (libraries) => (field) => libraries
        .find((library) => library.field === field);
      return this
        .focusedDiaryField
        .bind(findPhrasesByField(this.diaryPhraseLibraries));
    },
    /**
     * @description Фразы выбранной библиотеки протокола приема.
     * @type {string[]}
     */
    selectedDiaryLibraryPhrases() {
      return this.selectedDiaryLibrary.map(({ phrases }) => phrases).orSome([]);
    },
    /**
     * @description Группы выбранной библиотеки.
     * @returns {array}
     */
    selectedDiaryLibraryGroups() {
      return this.selectedDiaryLibrary.map(({ groups }) => groups).orSome([]);
    },
    /**
     * @description Текст кнопки сохранения шаблона фразы
     * @returns {string}
     */
    titleSaveButton() {
      return this.editingIdPhrase || this.editingGroupId ? 'Сохранить' : 'Добавить';
    },
    /**
     * @description Скрыть выбранную библиотеку фраз
     * @returns {boolean}
     */
    hideSelectedDiaryLibrary() {
      return !this.shownCreatePhraseForm
        && !this.showDeletePhraseDialog
        && !this.shownCreateGroupForm
        && !this.showDeleteGroupDialog;
    },
    inputDialogDiaryPhraseLibraryTitle() {
      return this.shownCreateGroupForm
        ? 'Введите название группы'
        : 'Введите слово или фразу, используя знаки препинания';
    },
  },
  data() {
    return {
      /**
       * @description Библиотеки фраз протокола приема.
       * @type {List<{field: string, phrases: string[]}>}
       */
      diaryPhraseLibraries: List(),
      /**
       * @description Идентификатор редактируемой группы.
       * @type {string|null}
       */
      editingGroupId: null,
      /**
       * @description Название редактирумой группы.
       * @type {string}
       */
      editingGroupTitle: '',
      /**
       * @description Идентификатор редактируемой фразы
       * @type {string|null}
       */
      editingIdPhrase: null,
      /**
       * @description Фраза
       * @type {string}
       */
      editedPhrase: '',
      /**
       * @description Сфокусированное поле протокола приема.
       * @type {Maybe<string>}
       */
      focusedDiaryField: Maybe.None(),
      /**
       * @description Показывать форму создания/редактирования фраз
       */
      shownCreatePhraseForm: false,
      /**
       * @description Показывать форму создания/редактирования групп.
       */
      shownCreateGroupForm: false,
      /**
       * @description Отображается окно удаления фразы
       */
      showDeletePhraseDialog: false,
      /**
       * @description Отображается окно удаления группы фраз
       */
      showDeleteGroupDialog: false,
      /**
       * @description Отображать диалоговое окно библиотеки фраз.
       */
      shownPhraseLibraryDialog: false,
      /**
       * @description Отображается категория "Мои шаблоны"
       */
      showMyTemplates: false,
      /**
       * @description Поле оиждает библиотеку после фокуса
       */
      isFieldAwaitLibrary: false,
      /**
       * @description Выбранная папка.
       */
      selectedGroupId: null,
    };
  },
  methods: {
    /**
     * @description Получить библиотеку фраз для поля протокола приема.
     * @param {string} field Поле.
     * @returns {Promise}
     */
    fetchDiaryLibrary(field) {
      return this
        .$patientGateway
        .viewDiaryPhraseLibrary(field)
        .then((result) => result.map((data) => {
          const assignPhraseFieldProps = (prefix) => (items, group) => items.map((item, index) => {
            const { title, type } = item;
            const key = `${prefix}:${index}-${type}`;
            const withChildren = type === 'group' || type === 'subgroup';
            const id = item.id ?? null;
            const value = withChildren ? assignPhraseFieldProps(key)(item.value, id) : item.value;
            return {
              key,
              title,
              value,
              withChildren,
              id,
              type,
              group,
            };
          });
          const assignGroupsFieldProps = (items) => items.reduce((groups, item) => {
            const { title, type } = item;
            const id = item.id ?? null;
            const withChildren = type === 'group' || type === 'subgroup';
            if (withChildren) {
              groups.push({ title, id });
              const value = withChildren ? assignGroupsFieldProps(item.value) : [];
              groups.push(...value);
            }
            return groups;
          }, []);
          return {
            field,
            groups: assignGroupsFieldProps(data.phrases),
            phrases: assignPhraseFieldProps(field)(data.phrases, null),
          };
        }))
        .then((library) => {
          this.diaryPhraseLibraries = library.toList();
          if (this.showMyTemplates) {
            this.showMyTemplates = false;
          }
          this.isFieldAwaitLibrary = false;
        });
    },
    /**
     * @description Произвести перемещение библиотеки фраз по DOM-у.
     * @param {object} targetField Выбранное поле.
     * @returns {void}
     */
    movePhraseLibraryUnderField(targetField) {
      if (this.isMobile && targetField) {
        const phraseLibrary = this.$refs.diaryPhraseLibraryRef.$el;
        const parentField = targetField.closest('.form-visit-diary');
        const collapseField = targetField.closest('.collapse-field');
        const nextCurrentField = collapseField.nextSibling;
        if (parentField && phraseLibrary) {
          parentField.insertBefore(phraseLibrary, nextCurrentField);
          collapseField.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    },
    /**
     * @description Обработать снятие фокуса с библиотеки фраз.
     * @returns {void}
     */
    onBlurDiaryLibrary({ relatedTarget }) {
      const isOutLibraryFocus = relatedTarget === null
        || relatedTarget.closest('.diary-phrase-library') === null;
      if (isOutLibraryFocus && this.hideSelectedDiaryLibrary) {
        this.focusedDiaryField = Maybe.None();
      }
    },
    /**
     * @description Обработать фокус поля протокола приема.
     * @param {string} field Название поля.
     * @returns {void}
     */
    onDiaryFieldFocus({ field, event }) {
      const targetField = event.target;
      this.isFieldAwaitLibrary = true;
      this.focusedDiaryField = Maybe.of(field);
      this.fetchDiaryLibrary(field);
      this.movePhraseLibraryUnderField(targetField);
    },
    /**
     * @description Очистить коллекцию выделенных фраз при очистке поля.
     * @param {string} field Название поля.
     * @returns {void}
     */
    onClearSelectedPhrases(field) {
      const phraseLibrary = this.$refs.diaryPhraseLibraryRef;
      if (phraseLibrary) {
        phraseLibrary.selectedPhrases = phraseLibrary
          .selectedPhrases.filter((elem) => !elem.startsWith(field));
      }
    },
    /**
     * @description Обработать ввод фразы из библиотеки.
     * @param {string} phrase Фраза.
     * @returns {void}
     */
    onInputDiaryPhrase(phrase) {
      this.diaries = this.diaries.map((item, index) => {
        if (index !== this.diaryTab) {
          return item;
        }
        return this
          .focusedDiaryFieldProperty
          .bind((property) => {
            if (Object.hasOwn(item, property)) {
              return Maybe.of(item.appendPhraseIntoField(property, phrase));
            }
            return Maybe.None();
          })
          .orSome(item);
      });
    },
    /**
     * @description Обработать сохранение новой/редактируемой фразы
     * @returns {void}
     */
    onSavePhrase() {
      if (this.editingIdPhrase) {
        this.onEditDiaryPhrase(this.editingIdPhrase, this.editedPhrase, this.selectedGroupId);
      } else {
        this.onCreateDiaryPhrase(this.focusedDiaryField, this.editedPhrase, this.selectedGroupId);
        this.showMyTemplates = true;
      }
    },
    /**
     * @description Обработать сохранение новой/редактируемой группы фраз
     * @returns {void}
     */
    onSaveGroup() {
      if (this.editingGroupId) {
        this.onEditDiaryGroup(this.editingGroupId, this.editingGroupTitle);
      } else {
        this.onCreateDiaryGroup(
          this.focusedDiaryField,
          this.editingGroupTitle,
          this.selectedGroupId,
        );
        this.showMyTemplates = true;
      }
    },
    /**
     * @description Создать шаблон фразы протокола лечения
     * @param {string} field            Поле привязки фразы
     * @param {string} phrase           Фраза
     * @param {string} selectedGroupId Идентификатор выбранной группы.
     * @returns {void}
     */
    onCreateDiaryPhrase(field, phrase, selectedGroupId) {
      this
        .$patientGateway
        .createDiaryPhrase(field.val, phrase, selectedGroupId)
        .then((result) => {
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.closePhraseLibraryDialog();
            this.fetchDiaryLibrary(this.focusedDiaryField.val);
          });
          result.forEachLeft(({ title }) => {
            this.notifyFail(title);
          });
        });
    },
    /**
     * @description Создать папку фраз протокола лечения
     * @param {string} field            Поле привязки фразы
     * @param {string} groupTitle      Название группы
     * @param {string} selectedGroupId Идентификатор выбранной группы.
     * @returns {void}
     */
    onCreateDiaryGroup(field, groupTitle, selectedGroupId) {
      this
        .$patientGateway
        .createDiaryGroup(field.val, groupTitle, selectedGroupId)
        .then((result) => {
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.closePhraseLibraryDialog();
            this.fetchDiaryLibrary(this.focusedDiaryField.val);
          });
          result.forEachLeft(({ title }) => {
            this.notifyFail(title);
          });
        });
    },
    /**
     * @description Удалить шаблон фразы протокола лечения
     * @param {string} phraseId Идентификатор фразы
     * @returns {void}
     */
    async onRemoveDiaryPhrase(phraseId) {
      this.showDeletePhraseDialog = true;
      const dialog = await this.showRemoveDialog('Вы действительно хотите удалить шаблон?');
      if (dialog.result !== DialogResult.DELETE) {
        this.showDeletePhraseDialog = false;
        return;
      }
      this
        .$patientGateway
        .removeDiaryPhrase(phraseId)
        .then((result) => {
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.fetchDiaryLibrary(this.focusedDiaryField.val);
            this.$nextTick(() => {
              this.$refs.diaryPhraseLibraryRef.$el.focus();
              this.showDeletePhraseDialog = false;
            });
          });
          result.forEachLeft(({ title }) => {
            this.notifyFail(title);
            this.showDeletePhraseDialog = false;
          });
        });
    },
    /**
     * @description Удалить папку фраз протокола лечения
     * @param {string} groupId Идентификатор группы
     * @returns {void}
     */
    async onRemoveDiaryGroup(groupId) {
      this.showDeleteGroupDialog = true;
      const dialog = await this.showRemoveDialog('При удалении группы будут удалены все фразы. Продолжить?');
      if (dialog.result !== DialogResult.DELETE) {
        this.showDeleteGroupDialog = false;
        return;
      }
      this
        .$patientGateway
        .removeDiaryGroup(groupId)
        .then((result) => {
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.fetchDiaryLibrary(this.focusedDiaryField.val);
            this.$nextTick(() => {
              this.$refs.diaryPhraseLibraryRef.$el.focus();
              this.showDeleteGroupDialog = false;
            });
          });
          result.forEachLeft(({ title }) => {
            this.notifyFail(title);
            this.showDeleteGroupDialog = false;
          });
        });
    },
    /**
     * @description Изменить шаблон фразы протокола лечения
     * @param {string} phraseId Идентификатор фразы
     * @param {string} phrase   Фраза
     * @param {string} selectedGroupId Идентификатор выбранной группы.
     * @returns {void}
     */
    onEditDiaryPhrase(phraseId, phrase, selectedGroupId) {
      this
        .$patientGateway
        .editDiaryPhrase(phraseId, phrase, selectedGroupId)
        .then((result) => {
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.closePhraseLibraryDialog();
            this.fetchDiaryLibrary(this.focusedDiaryField.val);
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
          });
        });
    },
    /**
     * @description Изменить папку фраз протокола лечения
     * @param {string} groupId    Идентификатор группы
     * @param {string} groupTitle Название
     * @returns {void}
     */
    onEditDiaryGroup(groupId, groupTitle) {
      this
        .$patientGateway
        .editDiaryGroup(groupId, groupTitle)
        .then((result) => {
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.closePhraseLibraryDialog();
            this.fetchDiaryLibrary(this.focusedDiaryField.val);
          });
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
        });
    },
    /**
     * @description Показ диалога создания новой фразы
     * @param {string|null} phraseId Идентификатор фразы
     * @param {string}      phrase   Фраза
     * @param {string|null} groupId  Идентификатор группы
     * @returns {void}
     */
    showCreatePhraseDialog(phraseId = null, phrase = '', groupId = null) {
      this.shownPhraseLibraryDialog = true;
      this.shownCreatePhraseForm = true;
      this.editingIdPhrase = phraseId;
      this.editedPhrase = phrase;
      this.selectedGroupId = groupId;
    },
    /**
     * @description Пока диалогового окна создания новой группы.
     * @param {string|null} groupId
     * @param {string} title
     */
    showCreateGroupDialog(groupId = null, title = '') {
      this.shownPhraseLibraryDialog = true;
      this.shownCreateGroupForm = true;
      this.editingGroupId = groupId;
      this.editingGroupTitle = title;
    },
    /**
     * @description Закрыть диалоговое окно библиотеки фраз.
     */
    closePhraseLibraryDialog() {
      this.shownPhraseLibraryDialog = false;
      this.shownCreateGroupForm = false;
      this.shownCreatePhraseForm = false;
    },
  },
  /**
   * @description Получить ключ поля протокола приема по сфокусированному полю.
   * @param {string} key Ключ поля.
   * @returns {(string|null)}
   */
  resolveDiaryFieldProperty: (key) => ({
    diagnosis: 'diagnosis',
    complaints: 'complaints',
    'dental-anamnesis': 'dentalAnamnesis',
    objectively: 'objectively',
    'status-lokalis': 'statusLokalis',
    studies: 'studies',
    treatment: 'treatment',
    recommendations: 'recommendations',
    guarantees: 'guarantees',
  })[key] || null,
};

/**
 * @description Примесь главного врача.
 * @type {Vue}
 */
const chiefPhysicianMixin = {
  computed: {
    /**
     * @description Показывать статус проверки главным врачом.
     * @type {boolean}
     */
    needShowChiefPhysicianStatus() {
      return this.chiefPhysicianStatusId !== '';
    },
  },
  data() {
    return {
      /**
       * @description Идентификатор статуса проверки главным врачом.
       * @type {string}
       */
      chiefPhysicianStatusId: '',
      /**
       * @description Название статуса проверки главным врачом.
       * @type {string}
       */
      chiefPhysicianStatusTitle: '',
      /**
       * @description Примечание к проверке главным врачом.
       * @type {string}
       */
      chiefPhysicianStatusNote: '',
    };
  },
};

/**
 * @description Форма протокола приема.
 * @type {Vue}
 */
const FormVisitDiary = {
  components: {
    CollapseField,
    InputCheckbox,
    TextareaLengthLimitation,
    TextareaView,
  },
  name: 'FormVisitDiary',
  props: {
    errorsComplaints: {
      default: [],
      type: Array,
    },
    errorsDiagnosis: {
      default: [],
      type: Array,
    },
    errorsDentalAnamnesis: {
      default: [],
      type: Array,
    },
    errorsGuarantees: {
      default: [],
      type: Array,
    },
    errorsObjectively: {
      default: [],
      type: Array,
    },
    errorsRecommendations: {
      default: [],
      type: Array,
    },
    errorsStudies: {
      default: [],
      type: Array,
    },
    errorsTreatment: {
      default: [],
      type: Array,
    },
    generalAnalysis: {
      required: true,
      type: String,
    },
    initialComplaints: {
      required: true,
      type: String,
    },
    initialDentalAnamnesis: {
      required: true,
      type: String,
    },
    initialDiagnosis: {
      required: true,
      type: String,
    },
    initialGuarantees: {
      required: true,
      type: String,
    },
    initialObjectively: {
      required: true,
      type: String,
    },
    initialRecommendations: {
      required: true,
      type: String,
    },
    initialSanitized: {
      required: true,
      type: Boolean,
    },
    initialStudies: {
      required: true,
      type: String,
    },
    initialTreatment: {
      required: true,
      type: String,
    },
    prognosis: {
      required: true,
      type: String,
    },
    statusLokalis: {
      required: true,
      type: String,
    },
    withoutEditableSanitized: {
      required: true,
      type: Boolean,
    },
    disabledField: {
      default: false,
      type: Boolean,
    },
  },
  render(createElement) {
    const createCollapseField = (isExpanded) => (props) => {
      const collapseFieldData = { props: { caption: props.title, value: isExpanded } };
      const onInput = (updatedValue) => this.$emit(`input-${props.key}`, updatedValue);
      const onClean = () => {
        this.$emit(`input-${props.key}`, '');
        this.$emit('clear-phrases', props.key);
      };
      const textareaElement = createElement(TextareaLengthLimitation, {
        nativeOn: {
          focusin: (event) => this.$emit('focus-field', { field: props.key, event }),
          focusout: (event) => this.$emit('blur-field', event),
        },
        on: { input: onInput, clean: onClean },
        props: {
          maxLength: 10000,
          placeholder: props.title,
          rows: 4,
          showCounter: false,
          showTitle: false,
          title: props.title,
          value: props.value,
          violations: props.violations,
          disabled: props.disabledField,
          isShowCleanerButton: props.isShowCleanerButton,
        },
      });
      return createElement(CollapseField, collapseFieldData, [textareaElement]);
    };
    const createExpandedField = (props) => createCollapseField(true)(props);
    const createCollapsedField = (props) => createCollapseField(false)(props);
    const createRemovedField = (props) => createElement(
      TextareaView,
      {
        on: {
          clean: () => {
            this.$emit(`input-${props.key}`, '');
            this.$emit('clear-phrases', props.key);
          },
        },
        props: {
          rows: 4,
          title: props.title,
          value: props.value,
          isShowCleanerButton: props.isShowCleanerButton,
        },
      },
    );
    const childElements = [
      createExpandedField({
        key: 'complaints',
        title: 'Жалобы',
        value: this.initialComplaints,
        violations: this.errorsComplaints,
        isShowCleanerButton: !!this.initialComplaints.length,
        disabledField: this.disabledField,
      }),
      createExpandedField({
        key: 'dental-anamnesis',
        title: 'Анамнез стоматологический',
        value: this.initialDentalAnamnesis,
        violations: this.errorsDentalAnamnesis,
        isShowCleanerButton: !!this.initialDentalAnamnesis.length,
        disabledField: this.disabledField,
      }),
      createExpandedField({
        key: 'objectively',
        title: 'Статус',
        value: this.initialObjectively,
        violations: this.errorsObjectively,
        isShowCleanerButton: !!this.initialObjectively.length,
        disabledField: this.disabledField,
      }),
      ...(this.statusLokalis.length === 0 ? [] : [
        createRemovedField({
          key: 'status-lokalis',
          title: 'Локальный статус',
          value: this.statusLokalis,
          isShowCleanerButton: !!this.statusLokalis.length,
        }),
      ]),
      createExpandedField({
        key: 'diagnosis',
        title: 'Клинический диагноз',
        value: this.initialDiagnosis,
        violations: this.errorsDiagnosis,
        isShowCleanerButton: !!this.initialDiagnosis.length,
        disabledField: this.disabledField,
      }),
      this.$slots.icd,
      createExpandedField({
        key: 'treatment',
        title: 'Лечение',
        value: this.initialTreatment,
        violations: this.errorsTreatment,
        isShowCleanerButton: !!this.initialTreatment.length,
        disabledField: this.disabledField,
      }),
      createCollapsedField({
        key: 'recommendations',
        title: 'Рекомендации',
        value: this.initialRecommendations,
        violations: this.errorsRecommendations,
        isShowCleanerButton: !!this.initialRecommendations.length,
        disabledField: this.disabledField,
      }),
      createCollapsedField({
        key: 'studies',
        title: 'Исследования',
        value: this.initialStudies,
        violations: this.errorsStudies,
        isShowCleanerButton: !!this.initialStudies.length,
        disabledField: this.disabledField,
      }),
      createCollapsedField({
        key: 'guarantees',
        title: 'Гарантии',
        value: this.initialGuarantees,
        violations: this.errorsGuarantees,
        isShowCleanerButton: !!this.initialGuarantees.length,
        disabledField: this.disabledField,
      }),
      ...(this.prognosis.length === 0 ? [] : [
        createRemovedField({
          title: 'Прогноз',
          value: this.prognosis,
        }),
      ]),
      ...(this.generalAnalysis.length === 0 ? [] : [
        createRemovedField({
          title: 'Общий анамнез',
          value: this.generalAnalysis,
        }),
      ]),
      createElement(InputCheckbox, {
        on: { input: (updatedValue) => this.$emit('input-sanitized', updatedValue) },
        props: {
          disabled: this.withoutEditableSanitized,
          title: 'Санирован',
          value: this.initialSanitized,
        },
      }),
    ];
    return createElement('form', { class: 'form-visit-diary' }, childElements);
  },
};

/**
 * @description Примесь услуг визита.
 * @type {Vue}
 */
const visitServiceMixin = {
  computed: {
    selectedServicesIds() {
      if (this.invoiceTab !== null) {
        const invoiceIndex = this.invoices.rows[this.invoiceTab]
          ? this.invoiceTab
          : 0;
        return this.invoices.rows[invoiceIndex].serviceTable.rows.map(
          (service) => service.serviceId,
        );
      }
      return [];
    },
  },
  data() {
    return {
      /**
       * @description Тип скидки.
       * @type {string}
       */
      discountType: DISCOUNT_IN_KOPECK,
      /**
       * @description Список услуг изменен.
       * @type {boolean}
       */
      invoicesIsChanged: false,
      /**
       * @description Услуги визита.
       * @type {ServiceTable}
       */
      serviceTable: new ServiceTable(),
      /**
       * @description Счета визита.
       * @type {Invoices}
       */
      invoices: new Invoices(),
      /**
       * @description Услуги визита.
       * @type {WorkOrderTable}
       */
      workOrderTable: new WorkOrderTable(),
      /**
       * @description Список названий и цен услуг.
       * @type {array}
       */
      serviceList: [],
    };
  },
  methods: {
    /**
     * @description Добавить услуги в таблицу услуг счета.
     * @param {number}          invoiceIndex
     * @param {PositionProps[]} services
     * @returns {void}
     */
    addServicesToInvoiceServiceTable(invoiceIndex, services) {
      this.invoices.rows[invoiceIndex].serviceTable.rows = [
        ...this.invoices.rows[invoiceIndex].serviceTable.rows,
        ...services,
      ];
      this.checkInvoiceServicesChanged();
    },
    /**
     * @description Проверить наличие изменений в таблице услуг счетов.
     * @returns {void}
     */
    checkInvoiceServicesChanged: debounce(function _() {
      this.invoicesIsChanged = this.invoices.isChanged()
        || this.invoices.rows.some((candidate) => !candidate.id);
    }, 300),
    /**
     * @description Проверить наличие изменений в таблице заказ-наряда.
     * @returns {void}
     */
    checkWorkOrderChanged: debounce(function _() {
      this.workOrderIsChanged = this.workOrderTable.isChanged();
    }, 300),
    /**
     * @description Привести скидку к копейкам.
     * @param {number} invoiceIndex
     * @returns {PositionProps[]}
     */
    convertDiscountToKopeck(invoiceIndex) {
      const newDiscountType = DISCOUNT_IN_KOPECK;
      const convert = (candidate) => {
        if (candidate.hasEditingRestrict) {
          return candidate.discount;
        }
        return candidate.discount.convertToKop(candidate.amount.toKop());
      };
      return this
        .invoices
        .rows[invoiceIndex]
        .serviceTable
        .rows
        .map(
          (candidate) => (candidate.discount.getType() === newDiscountType
            ? candidate
            : candidate.setDiscount(convert(candidate))
          ),
        );
    },
    /**
     * @description Привести скидку к процентам.
     * @param {number} invoiceIndex
     * @returns {PositionProps[]}
     */
    convertDiscountToPercent(invoiceIndex) {
      const newDiscountType = DISCOUNT_IN_PERCENT;
      const convert = (candidate) => {
        if (candidate.hasEditingRestrict) {
          return candidate.discount;
        }
        return new PositionDiscount(
          candidate.discount.getType(),
          candidate.discount.getValue(),
        ).convertToPercent(candidate.amount.toKop());
      };
      return this
        .invoices
        .rows[invoiceIndex]
        .serviceTable
        .rows
        .map(
          (candidate) => (candidate.discount.getType() === newDiscountType
            ? candidate
            : candidate.setDiscount(convert(candidate))
          ),
        );
    },
    /**
     * @description Обработать изменение услуги.
     * @param {number}        invoiceIndex
     * @param {number}        index
     * @param {PositionProps} value
     * @returns {void}
     */
    onChangeService(invoiceIndex, index, value) {
      this.invoices.rows[invoiceIndex].serviceTable.rows = this
        .invoices
        .rows[invoiceIndex]
        .serviceTable
        .rows
        .map(
          (candidate, candidateIndex) => (candidateIndex === index
            ? value
            : candidate),
        );
      this.checkInvoiceServicesChanged();
    },
    /**
     * @description Очистить таблицу услуг
     * @param {number} itemIndex
     * @returns {void}
     */
    onCleanServiceTable(itemIndex) {
      this.invoices.rows[itemIndex].serviceTable.rows = this
        .invoices
        .rows[itemIndex]
        .serviceTable
        .rows
        .filter(
          (candidate) => candidate.hasEditingRestrict === true,
        );
    },
    /**
     * @description Обработать удаление услуги.
     * @param {number} invoiceId
     * @param {number} invoiceIndex
     * @param {number} service
     * @returns {void}
     */
    async onDeleteService(invoiceId, invoiceIndex, service) {
      if (this.isAwaitRequest) {
        return;
      }
      const dialog = await this.showRemoveDialog('Вы действительно хотите удалить услугу?');
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      const removeService = () => {
        this.invoices.rows[invoiceIndex].serviceTable.rows = this
          .invoices
          .rows[invoiceIndex]
          .serviceTable
          .rows
          .filter(
            (candidate) => candidate !== service,
          );
      };
      if (!service.id) {
        removeService();
        return;
      }
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = (message) => {
        this.reloadVisitServiceList();
        this.invoices.refresh();
        this.notifySuccess(message);
      };
      this.isAwaitRequest = true;
      this
        .$visitGateway
        .deleteService(invoiceId, this.selectedVisitId, service.id)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать ввод типа скидки.
     * @param {number} itemIndex
     * @param {string} value
     * @returns {void}
     */
    onInputDiscountType(itemIndex, value) {
      this.invoices.rows[itemIndex].discountType = value;
      this.invoices.rows[itemIndex].serviceTable.rows = value === DISCOUNT_IN_KOPECK
        ? this.convertDiscountToKopeck(itemIndex)
        : this.convertDiscountToPercent(itemIndex);
      this.checkInvoiceServicesChanged();
    },
    /**
     * @description Обработать добавление услуги из прайса.
     * @param {number} invoiceIndex Индекс счета.
     * @param {Object} service Услуга.
     * @returns {void}
     */
    onAddingPriceService(invoiceIndex, service) {
      const invoice = this.invoices.rows[invoiceIndex];
      let discountValue = 0;
      if (this.patientLoyaltyCard?.isTypeDiscountCard()) {
        if (this.patientLoyaltyCard.hasLevel()) {
          discountValue = this
            .patientLoyaltyCard
            .level
            .resolveDiscount(invoice.discountType, service.cost);
        }
      }
      const currentService = new VisitPosition(
        false,
        service.categoryName,
        service.count,
        false,
        service.dentalParts || [],
        new PositionDiscount(invoice.discountType, discountValue),
        service.duration || 0,
        null,
        service.cost,
        service.id,
        service.name,
        service.teeth || [],
        service.units,
        `price-${service.id}-${Date.now()}`,
      );
      const index = this.invoices.rows[invoiceIndex].serviceTable.rows.findIndex(
        (item) => item.serviceId === currentService.serviceId,
      );
      if (index !== -1) {
        if (!this.invoices.rows[invoiceIndex].serviceTable.rows[index].id) {
          this.invoices.rows[invoiceIndex].serviceTable.rows.splice(index, 1);
        }
      } else {
        this.addServicesToInvoiceServiceTable(invoiceIndex, [currentService]);
      }
    },
    /**
     * @description Обработать изменение услуги в заказ-наряде.
     * @param {number}        index
     * @param {PositionProps} value
     * @returns {void}
     */
    onChangeServiceWorkOrder(index, value) {
      this.workOrderTable.rows = this.workOrderTable.rows.map(
        (candidate, candidateIndex) => (candidateIndex === index
          ? value
          : candidate),
      );
      this.checkWorkOrderChanged();
    },
    /**
     * @description Обработать удаление услуги в заказ-наряде.
     * @param {number}       index Номер строки.
     * @param {WorkOrderRow} row   Строка.
     * @returns {void}
     */
    async onDeleteServiceWorkOrder(index, row) {
      const dialog = await this.showRemoveDialog(' Вы действительно хотите удалить услугу?');
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      this.workOrderTable.rows = this.workOrderTable.rows.filter((candidate, i) => i !== index);
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = (message) => {
        this.workOrderTable.refresh();
        this.notifySuccess(message);
      };
      if (row.id) {
        this
          .$visitGateway
          .deleteWorkOrder(this.selectedVisitId, row.id)
          .then((result) => result.fold(onFail, onSuccess))
          .finally(() => { this.isAwaitRequest = false; });
      }
      this.checkWorkOrderChanged();
    },
    /**
     * @description Перезагрузить список визитов пациента.
     * @returns {void}
     */
    reloadVisitServiceList() {
      const onResponse = ({ invoices }) => {
        this.invoices = invoices;
      };
      this
        .$visitGateway
        .viewVisitServiceList(this.selectedVisitId)
        .then((result) => result.forEach(onResponse));
    },
  },
};

/**
 * @description Примесь заметок визита.
 * @type {Vue}
 */
const visitNoteMixin = {
  computed: {
    inputVisitNoteTextErrors: resolveInputErrors('visit-note-text'),
    visibleVisitNotes() {
      return this.showAllNotes
        ? this.visitNoteList
        : this.visitNoteList.slice(0, 5);
    },
  },
  data() {
    return {
      visitNote: '',
      visitNoteList: [],
      showAllNotes: false,
      unreadNotesCount: 0,
    };
  },
  methods: {
    /**
     * @description Обработать добавление заметки.
     * @returns {void}
     */
    onAddVisitNote() {
      const onSuccess = (message) => {
        this.notifySuccess(message);
        this.visitNote = '';
        this.fetchVisitNotes();
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.inputErrors = error.allCauses();
      };
      this.$visitGateway
        .createVisitNote(this.selectedVisitId, this.visitNote)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Получить список заметок по визиту.
     * @returns {void}
     */
    fetchVisitNotes() {
      if (!this.selectedVisitId || this.selectedVisitId === -1) {
        return;
      }
      const onSuccess = ({ notes, unreadCount }) => {
        this.visitNoteList = notes;
        this.unreadNotesCount = unreadCount;
        if (unreadCount > 0) {
          this.onMarkNoteAsRead();
        }
      };
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      this.$visitGateway
        .viewVisitNotes(this.selectedVisitId)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать изменение заметки.
     * @param {object} note
     * @returns {void}
     */
    onEditVisitNote(note) {
      const onSuccess = (message) => {
        this.notifySuccess(message);
        /* eslint-disable-next-line no-param-reassign */
        note.isEditing = false;
        this.fetchVisitNotes();
      };
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      this.$visitGateway
        .editVisitNote(this.selectedVisitId, note.id, note.editingText)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать отметку заметок, как прочитанных.
     * @returns {void}
     */
    onMarkNoteAsRead() {
      const onSuccess = () => {};
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      this.$visitGateway
        .markVisitNotesAsRead(this.selectedVisitId)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать удаление заметки.
     * @param {number} noteId
     * @returns {void}
     */
    async onRemoveVisitNote(noteId) {
      const dialog = await this.showRemoveDialog('Вы действительно хотите удалить заметку?');
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      const onSuccess = (message) => {
        this.notifySuccess(message);
        this.fetchVisitNotes();
      };
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      this.$visitGateway
        .deleteVisitNote(this.selectedVisitId, noteId)
        .then((result) => result.fold(onFail, onSuccess));
    },
  },
};

/**
 * @description Примесь CRM-заявки.
 * @type {Vue}
 */
const crmDealMixin = {
  neededCrmDealStageName: 'Записать на проф.гигиену',
  computed: {
    /**
     * @description Необходимо создать CRM-заявку.
     * @returns {boolean}
     */
    needCreateCrmDeal() {
      return this.visit.sanitized && this.visit.sanitizedIsChanged();
    },
    /**
     * @description CRM-заявка существует.
     * @returns {boolean}
     */
    crmDealExists() {
      return this.currentCrmDealStageName !== '';
    },
    /**
     * @description Текущий этап соответствует необходимому.
     * @returns {boolean}
     */
    currentStageConsistentNeededStage() {
      return this.currentCrmDealStageName === this.$options.neededCrmDealStageName;
    },
  },
  data() {
    return {
      /**
       * @description Название текущего этапа CRM-заявки.
       * @type {string}
       */
      currentCrmDealStageName: '',
    };
  },
  methods: {
    /**
     * @description Обработать событие разбора создания CRM-заявки.
     * @returns {Promise<CrmDealOptions|null>}
     */
    async onResolveCreateCrmDeal() {
      const stageMessage = ` "Работа с очередью" в этапе "${this.$options.neededCrmDealStageName}"`;
      if (!this.crmDealExists) {
        return this.createCrmDealOptions(true);
      }
      if (this.currentStageConsistentNeededStage) {
        const needUpdate = await this.handleDialog(`Обновить заявку по данному пациенту в воронке${stageMessage}?`);
        return needUpdate ? this.createCrmDealOptions(false) : null;
      }
      const shouldChangeStage = await this.handleDialog(
        `По данному пациенту уже существует заявка в воронке "Работа с очередью" в этапе "${this.currentCrmDealStageName}" сменить на этап "${this.$options.neededCrmDealStageName}"?`,
      );
      if (!shouldChangeStage) {
        const needCreate = await this.handleDialog(`Хотите создать дополнительную заявку в воронке${stageMessage}?`);
        return needCreate ? this.createCrmDealOptions(true) : null;
      }
      return this.createCrmDealOptions(false);
    },
    /**
     * @description Создать настройки CRM-заявки.
     * @param {boolean} isNew
     * @returns {CrmDealOptions}
     */
    createCrmDealOptions(isNew) {
      return new CrmDealOptions(this.$options.neededCrmDealStageName, isNew);
    },
    /**
     * @description Обработать данные диалогового окна.
     * @param {string} message
     * @returns {Promise<boolean>}
     */
    async handleDialog(message) {
      const dialog = await this.showAcceptDialog(message);
      return dialog.result === DialogResult.YES;
    },
  },
};

export default {
  components: {
    TheTooltip,
    InputAutocomplete,
    AutocompleteInput,
    PhraseLibrary,
    PriceListsSelectModal,
    TheRub,
    OralExamination,
    SearchInput,
    TeethSelectPopup,
    CollapseButton,
    DentalFormula,
    DragAndDropPatientFiles,
    FormVisitDiary,
    InputCheckbox,
    InputDiseaseSearch,
    InputTextLengthLimitation,
    InputTextSearch,
    MatchedServiceList,
    ModalDialog,
    ModalDialogPreventLeave,
    PatientProfile,
    PatientSection,
    PatientSectionControl,
    PickerServices,
    PopoverMenu,
    SelectItemTreeDialog,
    TabsItems,
    TextareaLengthLimitation,
    TheCarousel,
    TheSelect,
    TheTabs,
    VisitServiceTable,
    VisitWorkOrderTable,
    MobileFixedBottomPopup,
  },
  computed: {
    /**
     * @description Список визитов для карусели.
     * @returns {Array}
     */
    carouselVisitList() {
      return this.visitList.map((visit) => ({
        to: this.getNavigationToVisit(visit.id),
        visitFromList: visit,
      }));
    },
    /**
     * @description Список доступных докторов для записи.
     * @type {{id:number,name:string}[]}
     */
    allowedDoctorList({ visit, wasSelectedVisit, workingEmployeesList }) {
      if (wasSelectedVisit && visit.employeeId) {
        const currentDoctor = visit.getDoctor();
        return [...workingEmployeesList, currentDoctor];
      }
      return workingEmployeesList;
    },
    /**
     * @description Список доступного времени для записи.
     * @type {{datetime:string,title:string}[]}
     */
    allowedTimes({
      wasSelectedVisit, visit, timeLine, formatDateToISO,
    }) {
      if (wasSelectedVisit) {
        const result = [...timeLine];
        const isContains = (time) => timeLine.findIndex((item) => item.title === time) !== -1;
        const date = formatDateToISO(visit.date);
        const makeItem = (time) => {
          const datetime = `${date} ${time}:00`;
          return {
            datetime,
            title: time,
          };
        };
        if (!isContains(visit.startsTime)) {
          result.push(makeItem(visit.startsTime));
        }
        if (!isContains(visit.endsTime)) {
          result.push(makeItem(visit.endsTime));
        }
        return result.sort((a, b) => a.title > b.title);
      }
      return timeLine;
    },
    /**
     * @description Список доступных дней для записи.
     * @type {string[]}
     */
    allowedWorkDays({
      wasSelectedVisit, visit, workDays, formatDateToISO,
    }) {
      if (wasSelectedVisit) {
        return [...workDays, formatDateToISO(visit.date)];
      }
      return workDays;
    },
    /**
     * @description Дата визита.
     * @type {string}
     */
    dateAtTitle: (vm) => {
      const options = {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
      };
      return `${vm.visit.date.toLocaleDateString('ru-RU', options)}`;
    },
    /**
     * @description Может изменять скидки.
     * @type {boolean}
     */
    canChangeDiscount() {
      return true;
    },
    /**
     * @description Может проверять заполненность полей СЭМД.
     */
    canCheckCdaFields() {
      return this.actions.includes('check-cda-fields');
    },
    /**
     * @description Может видеть информацию по полям CRM.
     */
    canViewCdaFields() {
      return this.actions.includes('view-cda-fields');
    },
    /**
     * @description Может видеть счет.
     */
    canViewInvoice() {
      return this.actions.includes('view-invoice');
    },
    /**
     * @description Может удалять позиции.
     * @type {boolean}
     */
    canDeletePositions() {
      return this.actions.includes('delete-positions');
    },
    /**
     * @description Запрет на редактирование визита.
     * @returns {boolean|*}
     */
    restrictEditingVisit() {
      return this.canEditVisit !== true || this.restrictEditingBranchVisit;
    },
    /**
     * @description Может редактировать визит.
     * @returns {boolean}
     */
    canEditVisit() {
      return this.actions.includes('editing-visit');
    },
    /**
     * @description Запрет редактирования филиального визита.
     * @returns {boolean}
     */
    restrictEditingBranchVisit() {
      return this.actions.includes('restrict-editing-branch-visit');
    },
    restrictMessage() {
      return this.restrictEditingBranchVisit
        ? 'Редактирование визита недоступно. Внесение изменений возможно только в филиале, в котором был создан визит'
        : 'Время на редактирование карты истекло. Для внесения изменений обратитесь к руководителю.';
    },
    /**
     * @description Деактивировать кнопку сохранения визита.
     * @type {boolean}
     */
    isDisableSave({
      visitDateISO, visit, isAwaitRequest, isAllowedDate, needPreventLeave,
    }) {
      const isSaveVisit = visit.employeeId
        && isAllowedDate(visitDateISO)
        && visit.startsTime
        && visit.endsTime;
      return !isSaveVisit || isAwaitRequest || !needPreventLeave;
    },
    /**
     * @description Список визитов пуст.
     * @type {boolean}
     */
    isEmpty({ visitList, isNewVisit, isAwaitRequest }) {
      return !isNewVisit && visitList.length === 0 && !isAwaitRequest;
    },
    /**
     * @description Новый визит.
     * @type {boolean}
     */
    isNewVisit() {
      return this.selectedVisitId === null;
    },
    /**
     * @description Необходим безопасный выход.
     * @type {boolean}
     */
    needPreventLeave() {
      return this.visitIsChanged
        || this.diariesIsChanged
        || this.filesIsChanged
        || this.invoicesIsChanged
        || this.dentalFormulaIsChanged
        || this.dentalCavitiesIsChanged
        || this.workOrderIsChanged;
    },
    /**
     * @description Текст при пустом списке болезней.
     * @type {string}
     */
    noDataDisease({ queryDisease, isDiseasesLoad }) {
      if (isDiseasesLoad) {
        return 'Идет поиск';
      }
      if (queryDisease === '') {
        return 'Введите текст';
      }
      return 'Результатов нет';
    },
    /**
     * @description Источники оплаты по ЕГИСЗ НСИ для визита.
     */
    nsiMedicalCarePaymentSourcesForVisit() {
      const selectedValue = this.visit.nsiMedicalCarePaymentSource;
      return this.nsiMedicalCarePaymentSources.filter(
        ({ value, tags }) => (selectedValue === value || tags.includes('hidden') !== true),
      );
    },
    /**
     * @description Имеется филиальная система.
     * @returns {boolean}
     */
    hasBranchSystem() {
      return this.$store.getters.isSectionAvailable('branch-system');
    },
    /**
     * @description Имеются ли протоколы
     * @return {boolean}
     */
    hasDiaries() {
      return this.diaries.length > 0;
    },
    /**
     * @description Имеются ли шаблоны протоколов
     * @return {boolean}
     */
    hasDiaryTemplates() {
      return this.diaryTemplates.length > 0;
    },
    /**
     * @description Варианты шаблонов протоколов лечения.
     * @type {{title: string, value: string}[]}
     */
    optionsOfDiaryTemplates() {
      return this.diaryTemplates.map((template) => ({
        title: template.name,
        value: template.id,
      }));
    },
    /**
     * @description Идентификатор пациента.
     * @type {number}
     */
    patientId: (vm) => parseInt(vm.$route.params.id, 10),
    inputDiaryNameErrors: resolveInputErrors('diary.name'),
    inputDiaryTeethErrors: resolveInputErrors('diary.teeth'),
    inputAnamnesisDiagnosisErrors: resolveInputErrors('anamnesis.diagnosis'),
    inputComplaintsErrors: resolveInputErrors('diary.complaints'),
    inputIcdErrors: resolveInputErrors('diary.disease'),
    inputDentalAnamnesisErrors: resolveInputErrors('anamnesis.dental-anamnesis'),
    inputOcclusionErrors: resolveInputErrors('visit.occlusion'),
    inputGuaranteesErrors: resolveInputErrors('anamnesis.guarantees'),
    inputNsiConditionSeverenityErrors: resolveInputErrors('visit.nsi-condition-severenity'),
    inputNsiMedicalCarePaymentSourceErrors: resolveInputErrors('visit.nsi-medical-care-payment-source'),
    inputObjectivelyErrors: resolveInputErrors('anamnesis.objectively'),
    inputRecommendationsErrors: resolveInputErrors('anamnesis.recommendations'),
    inputStudiesErrors: resolveInputErrors('anamnesis.studies'),
    inputTreatmentErrors: resolveInputErrors('anamnesis.treatment'),
    categoryErrors: resolveInputErrors('input_category_id'),
    /**
     * @description Нарушения ограничений услуг.
     * @type {Object}
     */
    serviceViolations() {
      return Object
        .keys(this.inputErrors)
        .filter((key) => key.startsWith('service'))
        .reduce((acc, key) => {
          const parts = key.split('.');
          if (parts.length === 3) {
            const [, index, field] = parts;
            return set(acc, [index, field], this.inputErrors[key]);
          }
          return acc;
        }, {});
    },
    visitDateISO: ({ formatDateToISO, visit }) => formatDateToISO(visit.date),
    /**
     * @description Есть выбранный визит.
     * @type {boolean}
     */
    wasSelectedVisit({ selectedVisitId }) {
      return selectedVisitId !== null && selectedVisitId > -1;
    },
    /**
     * @description Деактивировать печать протокола.
     * @type {boolean}
     */
    isDisabledPrintProtocol() {
      return this.isEmptyProtocols || this.isNewVisit;
    },
    /**
     * @description Текст при наведении на кнопку печати протокола.
     * @type {string}
     */
    printProtocolText() {
      if (this.isEmptyProtocols) {
        return this.diariesIsChanged ? 'Сначала сохраните визит' : 'Заполните протокол';
      }
      return '';
    },
    doctorAssistanceExists() {
      return this.visit.doctorAssistant !== null;
    },
  },
  async created() {
    this.fetchTreatmentPlatTemplateCategories();
    this.viewPatientLoyaltyCard(this.patientId);
    await this
      .$visitGateway
      .viewVisitFillers(this.patientId)
      .then(async (result) => result.forEach((response) => {
        this.dentalFormulaDiagnoses = response.dentalFormulaDiagnoses;
        this.serviceGroupedByPriceList = response
          .priceLists
          .filter((item) => item.isHasServices());
        this.serviceCategoryList = response
          .priceLists
          .map((price) => price.categoryList)
          .flat();
        this.serviceList = this.serviceCategoryList.map(
          (category) => [
            category.services,
            category.children.map((subcategory) => subcategory.services).flat(),
          ].flat(),
        ).flat()
          .map((service) => ({ name: service.name, cost: service.cost }));
        this.treatmentPlanList = response.treatmentPlanList;
        this.setIemkFillers(response);
      }));
    await this.fetchDiaryTemplates();
    await this.fetchDiaryTemplateCategories();
    await this.reloadVisitList();
    const visit = Maybe
      .fromEmpty(Number(this.$route.params.visitId))
      .flatMap((id) => Maybe.fromEmpty(this.visitList.find((item, index) => {
        if (item.id === id) {
          this.selectedSlide = index;
          return item;
        }
        return null;
      })))
      .catchMap(() => Maybe.fromEmpty(this.visitList[0]));
    visit.forEach(({ id }) => { this.fetchVisit(id); });
    visit.orElseRun(() => { this.notifyFail('Визит не найден'); });
  },
  data() {
    const visit = new PatientVisit();
    const workingEmployeesList = [visit.getDoctor()];
    return {
      /**
       * @description Категории шаблонов планов лечения.
       * @type {Array<PlanCategory>}
       */
      treatmentsPlanTemplateCategories: [],
      /**
       * @description Доступные действия над визитом.
       * @type {string[]}
       */
      actions: [],
      /**
       * @description Индекс выбранной вкладки с протоколом.
       * @type {number}
       */
      diaryTab: null,
      /**
       * @description Набор шаблонов протоколов.
       * @type {Array}
       */
      diaryTemplates: [],
      diaryTemplatesIsLoaded: false,
      selectedDiaryTemplateCategory: null,
      diaryTemplateCategories: [],
      diaryTemplateCategoriesIsLoaded: false,
      /**
       * @description Дерево шаблонов протокола приема.
       */
      diaryTemplateTree: [],
      /**
       * @description Заголовок окна просмотра изображения.
       * @type {string}
       */
      dialogTitle: '',
      /**
       * @description Протоколы приема.
       * @type {array}
       */
      diaries: [new Diary()],
      /**
       * @description Исходные протоколы.
       * @type {string}
       */
      initialDiaries: '',
      /**
       * @description Заголовок протоколов приема.
       * @type {string}
       */
      diariesTitle: '',
      /**
       * @description Нельзя изменять статус санированности
       * @type {boolean}
       */
      diarySanitizedNotEditable: false,
      /**
       * @description Протоколы приема изменены.
       * @type {boolean}
       */
      diariesIsChanged: false,
      /**
       * @description Список результатов поиска болезней.
       * @type {any[]}
       */
      diseaseList: [],
      /**
       * @description Список файлов.
       * @type {any[]}
       */
      files: {
        /**
         * @description Текущий список файлов.
         * @type {any[]}
         */
        current: [],
        /**
         * @description Список файлов на удаление.
         * @type {any[]}
         */
        deleting: [],
        /**
         * @description Список файлов на загрузку.
         * @type {any[]}
         */
        uploading: [],
        /**
         * @description Список файлов загрузка которых не удалась.
         * @type {any[]}
         */
        error: [],
      },
      /**
       * @description Файлы изменены.
       * @type {boolean}
       */
      filesIsChanged: false,
      /**
       * @description Нужно сформировать черновик ЕГИСЗ.
       * @type {boolean}
       */
      needFormingDraftEgiszByVisit: false,
      /**
       * @description Пациента имеет ЗП.
       * @type {boolean}
       */
      hasGuardian: false,
      /**
       * @description Изображение.
       * @type {any}
       */
      imageSource: null,
      /**
       * @description Список услуг.
       * @type {any[]}
       */
      initialServices: [],
      /**
       * @description Нарушение ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Выполняется запрос.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Загрузка результатов поиска.
       * @type {boolean}
       */
      isDiseasesLoad: false,
      /**
       * @description Протоколы приема пустые.
       * @type {boolean}
       */
      isEmptyProtocols: true,
      /**
       * @description Инициализировать начальное время при получении временной шкалы.
       * @type {boolean}
       */
      isNeedInitializeTime: false,
      /**
       * @description Показывать просмотр изображения.
       * @type {boolean}
       */
      isShowImage: false,
      /**
       * @description Показывать файлы протокола.
       * @type {boolean}
       */
      isShowProtocolFiles: false,
      /**
       * @description Поисковой запрос болезни.
       * @type {string}
       */
      queryDisease: '',
      /**
       * @description Идентификатор выбранного визита.
       * @type {number|null}
       */
      selectedVisitId: -1,
      /**
       * @description Номер выбранного слайда.
       * @type {number|null}
       */
      selectedSlide: null,
      /**
       * @description Список категорий услуг.
       * @type {Array}
       */
      serviceCategoryList: [],
      /**
       * @description Список услуг сгруппированных по прайс-листам
       * @type {Array<PriceList>}
       */
      serviceGroupedByPriceLists: [],
      /**
       * @description Временная шкала.
       * @type {{datetime:string,title:string}[]}
       */
      timeLine: [],
      /**
       * @description Данные визита.
       * @type {PatientVisit}
       */
      visit,
      /**
       * @description Список визитов.
       * @type {any[]}
       */
      visitList: this.initialVisitList,
      /**
       * @description Список рабочих дней.
       * @type {string[]}
       */
      workDays: [],
      /**
       * @description Список докторов.
       * @type {{id:number,name:string}[]}
       */
      workingEmployeesList,
      /**
       * @description Визит изменен.
       * @type {boolean}
       */
      visitIsChanged: false,
      /**
       * @description заказ-наряд изменен.
       * @type {boolean}
       */
      workOrderIsChanged: false,
      /**
       * @description Настройки карусели.
       * @type {any}
       */
      carouselOptions: {
        arrows: true,
        infinite: true,
        draggable: false,
        slidesToShow: 6,
        speed: 500,
        responsive: [
          {
            breakpoint: 1750,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      /**
       * @description Индекс открытых секций.
       * @type {number[]}
       */
      openedSectionIndexes: [EGISZ_SECTION_INDEX],
      /**
       * @description Данные визита загружены.
       */
      visitIsLoaded: false,
      /**
       * @description Отобразить диалоговое окно шаблонов протокола приема.
       */
      shownDiaryTemplateDialog: false,
      /**
       * @description Деактивация кнопки модального окна предотавращающего переход.
       * @type {boolean}
       */
      isDisabledPreventLeaveSaveButton: false,
      /**
       * @description Редактирование наименования протокола приема.
       * @type {number|null}
       */
      indexEditDiaryName: null,
      diaryTabKey: 0,
      /**
       * @description Карта лояльности пациента
       * @type {PatientLoyaltyCard|null}
       */
      patientLoyaltyCard: null,
    };
  },
  methods: {
    /**
     * @description Просмотреть карту лояльности пациента
     * @param patientId
     */
    viewPatientLoyaltyCard(patientId) {
      const onSuccess = ({ card }) => {
        this.patientLoyaltyCard = card;
      };
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      this
        .$loyaltySystemGateway
        .viewPatientLoyaltyCard(patientId)
        .then((either) => {
          either.fold(onFail, onSuccess);
        });
    },
    /**
     * @description Обработать событие клика по кнопке  "Добавить из плана лечения"
     * @returns {void}
     */
    onClickAddTreatmentPlanTemplate() {
      this.shownAddingServicesFromTreatmentPlansModal = true;
      this.reachGoalIfNotReach(GOAL_ADDING_TREATMENT_PLAN_SERVICE);
    },
    /**
     * @description Достигнута цель - добавить услугу в заказ наряд
     * @returns {void}
     */
    onReachAddServiceGoal() {
      this.reachGoalIfNotReach(GOAL_ADD_SERVICES_TO_CUSTOM_ORDER_PATIENT_VISITS);
    },
    /**
     * @description К счёту пациента
     * @param {string}id
     * @returns {void}
     */
    toPatientInvoice(id) {
      this.reachGoalIfNotReach(GOAL_TO_INVOICE_PATIENT_VISITS);
      this.$router.push(this.getNavigationToInvoice(id));
    },
    /**
     * @description Обработать клик на форму с файлами
     * @returns {void}
     */
    onClickFileForm() {
      this.reachGoalIfNotReach(GOAL_ATTACH_FILE_PATIENT_VISITS);
    },
    /**
     * @description К другому визиту.
     * @param to
     */
    toAnotherVisit(to) {
      this.reachGoalIfNotReach(GOAL_TO_ANOTHER_VISIT_PATIENT_VISITS);
      this.$router.push(to);
    },
    /**
     * @description Затянуть категории шаблонов планов лечения.
     * @returns {void}
     */
    async fetchTreatmentPlatTemplateCategories() {
      this.$planGateway
        .getCategories()
        .then((result) => {
          result.forEach((categories) => {
            this.treatmentsPlanTemplateCategories = categories;
            this.isAwaitTemplates = false;
          });
        })
        .finally(() => {
          this.isAwaitTemplates = false;
        });
    },
    /**
     * @description Создать новый протокол приема.
     * @returns {void}
     */
    createDiary() {
      const name = `Протокол ${this.diaries.length + 1}`;
      this.diaries = this.diaries.concat(
        new Diary(name, this.visit.getDoctor()),
      );
      this.$nextTick(() => { this.diaryTab = this.diaries.length - 1; });
    },
    /**
     * @description Инициализировать протоколы приема.
     * @returns {void}
     */
    initializeDiaries() {
      this.createDiary();
      if (this.visit.doctorAssistant) {
        const name = `Протокол ${this.diaries.length + 1}`;
        this.diaries = this.diaries.concat(
          new Diary(name, this.visit.doctorAssistant),
        );
      }
    },
    createDiaryTemplate() {
      const name = this.diaryTemplateName;
      const data = this.diaries[this.diaryTab];
      const request = this.makeRequestCreateDiaryTemplate(name, data);
      this
        .$visitGateway
        .createDiaryTemplate(request.toQuery())
        .then((result) => {
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.isShownDiaryTemplateCreateDialog = false;
            this.diaryTemplateName = '';
            this.fetchDiaryTemplates();
            this.reachGoalIfNotReach(GOAL_SAVE_PROTOCOL_AS_TEMPLATE_PATIENT_VISITS);
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.getTitle());
            this.inputErrors = error.allCauses();
          });
        });
    },
    /**
     * @description Создать запрос на создание шаблона проктокола приема.
     * @returns {Object}
     */
    makeRequestCreateDiaryTemplate(name, data) {
      return new DiaryTemplateCreationRequest(
        null,
        name,
        this.selectedDiaryTemplateCategory,
        data.complaints,
        data.dentalAnamnesis,
        data.diagnosis,
        data.generalAnalysis,
        data.guarantees,
        data.icdId,
        data.objectively,
        data.prognosis,
        data.recommendations,
        data.studies,
        data.treatment,
        data.teeth,
        data.dentalParts,
        data.sanitized,
      );
    },
    /**
     * @description Получить шаблоны протокола приема.
     * @returns {void}
     */
    fetchDiaryTemplates() {
      this.diaryTemplatesIsLoaded = false;
      this
        .$visitGateway
        .getDiaryTemplates()
        .then((list) => {
          this.diaryTemplates = list;
          this.diaryTemplatesIsLoaded = true;
        });
    },
    fetchDiaryTemplateCategories() {
      this.diaryTemplateCategoriesIsLoaded = false;
      this
        .$visitGateway
        .getDiaryTemplateCategoryList()
        .then((list) => {
          this.diaryTemplateCategories = list;
          this.diaryTemplateCategoriesIsLoaded = true;
        });
    },
    /**
     * @description Получить список категорий шаблонов протокола приема.
     * @returns {void}
     */
    async getDiaryTemplateCategoriesList() {
      this.diaryTemplateTree = this.diaryTemplateCategories.map((item) => ({
        id: item.id,
        name: item.name,
        children: [],
      }));
    },
    /**
     * @description Получить шаблоны по категории.
     * @param {Object} item
     * @returns {void}
     */
    async getDiaryTemplateChildren(item) {
      const childrens = this
        .diaryTemplates
        .filter((template) => template.category_id === item.id)
        .map((template) => ({
          id: template.id,
          name: template.name,
        }));
      item.children.push(...childrens);
    },
    /**
     * @description Обработать изменение шаблона протокола.
     * @param {Object} item
     * @returns {void}
     */
    onChangeDiaryTemplate(item) {
      this.onApplyDiaryTemplate(item.id);
      this.shownDiaryTemplateDialog = false;
    },
    /**
     * @description Обработать применение шаблона к текущему плану.
     * @param {number} templateId Идентификатор шаблона.
     * @returns {void}
     */
    onApplyDiaryTemplate(templateId) {
      if (this.diaries[this.diaryTab].templateId === templateId) {
        return;
      }
      this.diaryTemplates
        .flatMap((item) => (item.id === templateId ? [item] : []))
        .forEach((item) => {
          this.diaries[this.diaryTab].templateId = item.id;
          this.diaries[this.diaryTab].complaints = item.complaints;
          this.diaries[this.diaryTab].dentalAnamnesis = item.dental_anamnesis;
          this.diaries[this.diaryTab].diagnosis = item.diagnosis;
          this.diaries[this.diaryTab].guarantees = item.guarantees;
          this.diaries[this.diaryTab].objectively = item.objectively;
          this.diaries[this.diaryTab].recommendations = item.recommendations;
          this.diaries[this.diaryTab].sanitized = item.sanitized;
          this.diaries[this.diaryTab].studies = item.studies;
          this.diaries[this.diaryTab].treatment = item.treatment;
          this.diaries[this.diaryTab].icdId = item.icd_id;
          this.onTextChange(item.icd_name);
          this.addToDiariesFields(this.diaryTab, this.diaries[this.diaryTab].teeth);
        });
      this.$goal(GOAL_APPLY_DIARY_TEMPLATE);
    },
    /**
     * @description Обработать удаление протокола приема.
     * @param {number} diaryIndex Идентификатор протокола приема.
     * @returns {void}
     */
    async onDeleteDiary(diaryIndex) {
      if (this.isAwaitRequest) {
        return;
      }
      const dialog = await this.showRemoveDialog(
        'При удалении протокола все данные будут утеряны. Удалить?',
      );
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      const diary = this.diaries[diaryIndex];
      if (diary.id === null) {
        this.diaries.splice(diaryIndex, 1);
      } else {
        const onSuccess = (response) => {
          this.notifySuccess(response.message);
          this.diaries = this.diaries.filter((candidate) => candidate !== diary);
        };
        this.isAwaitRequest = true;
        this
          .$visitGateway
          .deleteDiary(diary.id)
          .then((result) => result.fold(this.notifyFail, onSuccess))
          .finally(() => { this.isAwaitRequest = false; });
      }
    },
    /**
     * @description Обработать открытие диалогового окна шаблонов протокола приема.
     * @returns {void}
     */
    onShowDiaryTemplateDialog(index) {
      this.shownDiaryTemplateDialog = true;
      this.selectedDiaryIndex = index;
    },
    /**
     * @description Прокрутить до нового протокола приема.
     * @returns {void}
     */
    scrollToNewDiary() {
      this.$refs.diariesContainer.$el.scrollIntoView({ behavior: 'smooth' });
    },
    /**
     * @description Отобразить поле ввода наименования протокола приема.
     * @param {number} index
     */
    showInputDiaryName(index) {
      this.indexEditDiaryName = index;
      const diaryRef = `diaryName-${index}`;
      this.$nextTick(() => this.$refs[diaryRef].focus());
    },
    /**
     * @description Получить имя заболевания для протокола приема.
     * @returns {string}
     */
    getDiaryDiseaseName(diary) {
      return this.diseaseList.filter(({ id }) => id === diary.icdId).map(({ name }) => name)[0] || '';
    },
    /**
     * @description Обработать ввод зубов.
     * @param {number} index        Индекс.
     * @param {int[]}  teeth        Номера зубов.
     * @param {any[]}  dentalParts  Стоматологические части.
     * @returns {void}
     */
    onSubmitTeethDiary(index, teeth, dentalParts) {
      const item = this.diaries[index];
      item.teeth = teeth;
      item.dentalParts = dentalParts;
      this.$goal(GOAL_SELECT_TEETH_DIARY);
    },

    /**
     * @description Добавить к полям протокола приёма.
     * @param diaryIndex
     * @param teeth
     * @param dentalParts
     */
    addToDiariesFields(diaryIndex, teeth, dentalParts = []) {
      this.refreshTeethNumber(diaryIndex);
      if (teeth.length === 0 && dentalParts.length === 0) {
        return;
      }
      const segments = this.groupTeethInSegments(teeth);
      const parts = dentalParts.map(({ title }) => title);
      const partSegments = parts.join(', ');
      const formattedString = [segments, partSegments].filter((segment) => segment !== '').join(', ');
      if (formattedString) {
        this.updateDiaryFields(diaryIndex, (fieldValue) => `${formattedString} \n${fieldValue}`);
      }
    },

    /**
     * @description Сбросить номера зубов.
     * @param diaryIndex
     * @return {void}
     */
    refreshTeethNumber(diaryIndex) {
      const oldTeeth = this.diaries[diaryIndex].teeth;
      const oldParts = this.diaries[diaryIndex].dentalParts;
      const segments = this.groupTeethInSegments(oldTeeth);
      const parts = oldParts.map(({ title }) => title);
      const partSegments = parts.join(', ');
      const formattedString = [segments, partSegments].filter((segment) => segment !== '').join(', ');
      if (!formattedString) {
        return;
      }
      const escapedString = formattedString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`^${escapedString}\\s*\\n?`, 'i');
      this.updateDiaryFields(
        diaryIndex,
        (fieldValue) => fieldValue.replace(regex, ''),
      );
    },

    /**
     * @description Обновить все поля дневника.
     * @param diaryIndex     Индекс протокола.
     * @param updateFunction Функция, принимающая текущее значение поля и возвращающая новое.
     * @return {void}
     */
    updateDiaryFields(diaryIndex, updateFunction) {
      const diaries = this.diaries[diaryIndex];
      const fields = [
        'complaints',
        'dentalAnamnesis',
        'diagnosis',
        'recommendations',
        'guarantees',
        'treatment',
        'objectively',
        'studies',
      ];

      fields.forEach((field) => {
        diaries[field] = updateFunction(diaries[field]);
      });
    },
    /**
     * @description Показывать иконку зуба.
     * @param {number} index
     * @type {boolean}
     */
    shownToothIconDiary(index) {
      return this.diaries[index].teeth.length + this.diaries[index].dentalParts.length === 0;
    },
    /**
     * @description Текстовый спсиок зубов.
     * @param {number} index
     * @type {string}
     */
    teethTextDiary(index) {
      const segments = this.groupTeethInSegments(this.diaries[index].teeth);
      const parts = this.diaries[index].dentalParts.map(({ title }) => title);
      const partSegments = parts.join(', ');
      return [segments, partSegments].filter((segment) => segment !== '').join(', ');
    },
    /**
     * @description Получить навигацию до визита.
     * @param {number} visitId Идентификатор визита.
     * @returns {Object}
     */
    getNavigationToVisit(visitId) {
      return {
        name: 'ClinicPanelPatientVisit',
        params: {
          visitId,
          id: this.patientId,
        },
      };
    },
    /**
     * @description Перед закрытием визита.
     * @param {function} action Действие.
     * @returns {void}
     */
    beforeVisitLeave(action) {
      if (this.needPreventLeave) {
        this.actionAfterClosingDialogLeaveConfirm = action;
        this.isShownDialogLeaveConfirm = true;
      } else {
        action();
      }
    },
    /**
     * @description Редактировать компоненты визита.
     * @param {Promise<Validation>} editVisitRequest
     * @returns {Promise<Validation>}
     */
    async editComponentsOfVisit(editVisitRequest) {
      const requests = [editVisitRequest];
      if (editVisitRequest.isSuccess()) {
        if (this.filesIsChanged) {
          requests.push(this.onUpdateFiles());
        }
        if (this.invoicesIsChanged) {
          requests.push(this.onUpdateServiceTableWithInvoices());
        }
        if (this.workOrderIsChanged) {
          requests.push(this.onUpdateWorkOrderTable());
        }
        if (this.diariesIsChanged) {
          this
            .diaries
            .filter((diary) => diary.isChanged() && diary.id !== null)
            .forEach((diary) => requests.push(this.onEditDiary(this.selectedVisitId, diary)));
          this
            .diaries
            .filter((diary) => diary.id === null)
            .forEach((diary) => requests.push(this.onCreateDiary(this.selectedVisitId, diary)));
        }
        if (this.dentalFormulaIsChanged) {
          requests.push(this.sendDentalFormulaEditRequest());
        }
        if (this.dentalCavitiesIsChanged) {
          requests.push(this.sendDentalCavitiesEditRequest());
        }
      }
      let message = 'Визит обновлен';
      return Promise.all(requests).then((responses) => {
        const errorTitles = [];
        this.inputErrors = {};
        responses.forEach((result) => {
          result.forEach((fields) => {
            if (fields.hasImportantNotification === true) {
              message = fields.message;
            }
          });
          result.forEachFail((error) => {
            const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
            errorTitles.push(error.title);
            Object.assign(this.inputErrors, Object.fromEntries(failurePairs));
          });
        });
        if (errorTitles.length === 0) {
          return Validation.Success({ message });
        }
        this.openSectionWithErrors();
        this.scrollToInvalidField();
        return Validation.Fail({ message: errorTitles.join('\n') });
      });
    },
    /**
     * @description Скролл к невалидному полю.
     * @returns {void}
     */
    scrollToInvalidField() {
      this.$nextTick(() => {
        const firstInvalidField = document.querySelector('[aria-invalid="true"]');
        if (firstInvalidField) {
          firstInvalidField.scrollIntoView({ block: 'center', behavior: 'smooth' });
          firstInvalidField.focus({ preventScroll: true });
        }
      });
    },
    /**
     * @description Открыть секцию с ошибками.
     * @returns {void}
     */
    openSectionWithErrors() {
      const hasDiaryErrors = Object.keys(this.inputErrors).some(
        (candidate) => DIARY_SECTION_ERROR_FIELD_KEYS.includes(candidate),
      );
      if (!this.hasDiaries && hasDiaryErrors) {
        this.createDiary();
      }
      if (hasDiaryErrors && !this.openedSectionIndexes.includes(DIARY_SECTION_INDEX)) {
        this.openedSectionIndexes.push(DIARY_SECTION_INDEX);
      }
      const hasEgisErrors = Object.keys(this.inputErrors).some(
        (candidate) => EGISZ_SECTION_ERROR_FIELD_KEYS.includes(candidate),
      );
      if (hasEgisErrors && !this.openedSectionIndexes.includes(EGISZ_SECTION_INDEX)) {
        this.openedSectionIndexes.push(EGISZ_SECTION_INDEX);
      }
    },
    /**
     * @description Получить список рабочих дней клиники.
     * @param {string} yearAndMonth
     * @returns {Promise<string[]>}
     */
    async fetchClinicWorkDays(yearAndMonth = 'now') {
      const days = await this.$appointmentScheduleGateway.viewClinicWorkDays(false, yearAndMonth);
      return days.fold([])((value) => value);
    },
    /**
     * @description Получить список заболевание по МКБ-10.
     * @param {string} query Поиск.
     * @returns {void}
     */
    async fetchDiseases(query = '') {
      this.isDiseasesLoad = true;
      (await this.$visitGateway.viewDiseaseList(query)).forEach((list) => {
        const toConcat = list.filter(
          (newElem) => !this.diseaseList.find((existElem) => newElem.id === existElem.id),
        );
        this.diseaseList = this.diseaseList.concat(toConcat);
      });
      this.isDiseasesLoad = false;
    },
    /**
     * @description Обработать изменение МКБ.
     * @param {Object} item
     * @returns {void}
     */
    onChangeIcd(item) {
      if (!this.diseaseList.find((elem) => elem.id === item.id)) {
        this.diseaseList.push(item);
      }
      this.diaries[this.selectedDiaryIndex].icdId = item.id;
      this.showDiseasesDialog = false;
    },
    /**
     * @description Получить список рабочих дней сотрудника.
     * @param {number} employeeId
     * @param {string} yearAndMonth
     * @returns {Promise<string[]>}
     */
    async fetchEmployeeWorkDays(employeeId, yearAndMonth = 'now') {
      const onFail = () => [];
      const onSuccess = (days) => days;
      const days = await this.$employeeGateway.viewWorkDays(employeeId, yearAndMonth, false);
      return days.fold(onFail, onSuccess);
    },
    /**
     * @description Получить проверку заполнения.
     * @param {string} visitId
     * @returns {void}
     */
    fetchFullnessVisit(visitId) {
      this
        .$chiefPhysicianGateway
        .checkCdaConsultationProtocolForVisit(visitId)
        .then((result) => {
          result.forEachLeft((error) => {
            const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
            this.inputErrors = Object.fromEntries(failurePairs);
            this.openSectionWithErrors();
            this.scrollToInvalidField();
          });
        });
    },
    /**
     * @description Получить временную шкалу на день.
     * @param {string} date Дата.
     * @param {number} step Временной шаг.
     * @returns {Promise<{datetime:string, title:string}[]>}
     */
    async fetchTimeLine(date, step = 5) {
      const onFail = () => [];
      const onSuccess = (timeLine) => timeLine;
      const timeLine = await this.$appointmentScheduleGateway.viewTimeLine(date, step);
      return timeLine.fold(onFail, onSuccess);
    },
    /**
     * @description Получить временные отрезки с шагом от сотрудника
     * @param {string} date дата
     * @param {number} step Шаг
     */
    fetchTimeLineForNewVisitWithSelectedEmployee(date, step) {
      const dateISO = this.formatDateToISO(date);
      this.fetchTimeLine(dateISO, step).then((timeLine) => {
        if (this.isNeedInitializeTime) {
          this.initializeTime(timeLine);
        }
        this.timeLine = timeLine;
      });
    },
    /**
     * @description Получить данные визита.
     * @param {number} id Идентификатор визита.
     * @returns {Promise<void>}
     */
    async fetchVisit(id) {
      this.isAwaitRequest = true;
      const either = await this.$visitGateway.viewVisitById(this.patientId, id);
      either.forEach((response) => {
        this.actions = response.actions;
        this.chiefPhysicianStatusId = response.chiefPhysicianStatus.getId();
        this.chiefPhysicianStatusTitle = response.chiefPhysicianStatus.getTitle();
        this.chiefPhysicianStatusNote = response.chiefPhysicianStatus.getNote();
        this.diaries = response.diaries;
        this.diariesTitle = response.diariesTitle;
        this.visit = response.visit;
        this.dentalFormulaTeeth = response.toothList;
        this.dentalCavities = response.dentalCavities;
        this.initialDentalFormulaAsString = this.dentalFormulaAsString;
        this.invoices = response.invoices;
        this.workOrderTable.rows = response.workOrder.map((item) => (new WorkOrderRow(
          item.id,
          item.serviceName,
          item.teeth,
          item.dentalParts,
          item.count,
          item.price,
          item.vita,
        )));
        this.workOrderTable.refresh();
        this.setIemkViewData(response);
        this.initialBiteMode = response.biteMode;
        this.biteMode = response.biteMode;
        this.initialIsDetailedDentalFormula = response.isDetailedDentalFormula;
        this.currentCrmDealStageName = response.currentCrmDealStageName;
        this.invoiceId = response.invoiceId;
        this.invoiceActions = response.invoiceActions;
        this.isDetailedDentalFormula = this.initialIsDetailedDentalFormula;
        this.$set(this.files, 'current', response.files);
        this.selectedVisitId = id;
        this.hasGuardian = response.hasGuardian;
        this
          .diaries
          .map((diary) => diary.icdId)
          .forEach((icdId) => this.fetchDiseases(icdId));
        this
          .diaries
          .map((diary) => diary.id)
          .forEach((idDiary) => this.selectedDiariesForPrint.push(idDiary));
        this.printDocumentList = response.documents;
        this.downloadDocumentList = response.downloadDocuments;
        this.isEmptyProtocols = this.diaries.length === 0;
        if (response.discountType === DISCOUNT_MIXED) {
          this.onInputDiscountType(0, DISCOUNT_IN_KOPECK);
        } else {
          this.discountType = response.discountType;
        }
        if (
          this.visit.nsiMedicalCarePaymentSource.length === 0
          && !this.hasGuardian
          && this.canCheckCdaFields
        ) {
          this.visit.nsiMedicalCarePaymentSource = this
            .nsiMedicalCarePaymentSourcesForVisit
            .find((item) => item.title === 'Средства пациента')
            .value ?? '';
          this.visit.refresh();
        }
        if (!this.restrictEditingBranchVisit && !this.hasDiaries) {
          this.initializeDiaries();
        }
        this.initialDiaries = JSON.stringify(this.diaries);
        this.visitIsLoaded = true;
        this.fetchVisitNotes();
      });
      either.forEachFail((error) => {
        this.notifyFail(error.title);
      });
      this.isAwaitRequest = false;
    },
    /**
     * @description Получить список работающих сотрудников на день.
     * @param {Date} date Дата.
     * @param {number} step Шаг.
     * @returns {void}
     */
    async fetchWorkingEmployees(date, step = 5) {
      const dateISO = this.formatDateToISO(date);
      this.fetchTimeLine(dateISO, step).then((timeLine) => {
        if (this.isNeedInitializeTime) {
          this.initializeTime(timeLine);
        }
        this.timeLine = timeLine;
      });
      const list = await this.$appointmentScheduleGateway.viewWorkingEmployeeList(dateISO, 'day');
      list.forEach((val) => {
        this.workingEmployeesList = val;
      });
    },
    /**
     * @description Проинициализировать время визита.
     * @param {{title: string}[]} timeLine
     * @returns {void}
     */
    initializeTime(timeLine) {
      const now = new Date();
      const hour = now.getHours().toString().padStart(2, '0');
      const min = now.getMinutes().toString().padStart(2, '0');
      const time = `${hour}:${min}`;
      const index = timeLine.findIndex((item) => item.title >= time);
      if (index !== -1) {
        const { title: startsTime } = timeLine[index];
        const { title: endsTime } = timeLine[index + 1] || timeLine[index];
        this.visit.startsTime = startsTime;
        this.visit.endsTime = endsTime;
      }
      this.isNeedInitializeTime = false;
    },
    /**
     * @description Проверить доступность даты для записи.
     * @param {string} value
     * @returns {boolean}
     */
    isAllowedDate(value) {
      return this.allowedWorkDays.includes(value);
    },
    /**
     * @description Проверка является ли файл картинкой.
     * @param {string} type
     * @param {string} fileName
     * @returns {boolean}
     */
    isImage(type, fileName = '') {
      if (type.split('/')[0] === 'image') {
        return true;
      }
      const access = ['jpg', 'jpeg', 'png', 'gif'];
      return access.includes(fileName.split('.').pop());
    },
    /**
     * @description Обработать добавление файла в список на удаление.
     * @param {any} file Файл.
     * @returns {void}
     */
    async onAddFileToDeleted(file) {
      const dialog = await this.showRemoveDialog('Вы действительно хотите удалить файл?');
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      if (file.id) {
        this.files.current = this.files.current.filter((item) => item.id !== file.id);
        this.files.deleting.push(file.id);
      } else {
        this.files.uploading = this.files.uploading.filter((item) => item !== file);
      }
    },
    /**
     * @description Обработать добавление файла в список на загрузку.
     * @param {File} file Файл.
     */
    onAddFileToUploaded(file) {
      this.files.uploading.push(file);
    },
    /**
     * @description Показ диалога выбора мкб
     * @param index
     */
    onShowDiseasesDialog(index) {
      this.showDiseasesDialog = true;
      this.selectedDiaryIndex = index;
    },
    /**
     * @description Обработать изменение месяца.
     * @param {string} yearAndMonth
     * @return {void}
     */
    async onChangeMonth(yearAndMonth) {
      const { employeeId } = this.visit;
      if (employeeId) {
        this.workDays = await this.fetchEmployeeWorkDays(employeeId, yearAndMonth);
      } else {
        this.workDays = await this.fetchClinicWorkDays(yearAndMonth);
      }
    },
    /**
     * @description Обработать создание нового визита.
     * @returns {void}
     */
    onCreateNewVisit() {
      this.dentalFormula = Maybe.None();
      this.selectedVisitId = null;
      this.diaries = [new Diary()];
      this.files.current = [];
      this.files.deleting = [];
      this.files.error = [];
      this.files.uploading = [];
      this.inputErrors = {};
      this.invoices = new Invoices();
      this.visit = new PatientVisit();
      this.dentalFormulaTeeth = this.defaultDentalFormula.make();
      this.isNeedInitializeTime = true;
    },
    /**
     * @description Обработать сохранение нового визита.
     * @returns {Promise<void>}
     */
    async onCreateVisit() {
      const result = await this.sendCreateVisitRequest(
        this.diaries,
        this.patientId,
        this.workOrderTable,
        this.serviceTable,
        this.dentalFormulaTeeth,
        this.visit,
      );
      result.forEach(async ({ message, visit_id: visitId }) => {
        this.reloadVisitList();
        await this.fetchVisit(visitId);
        if (this.files.uploading.length > 0) {
          const uploadingResult = await this.sendUploadFilesRequest(visitId, this.files.uploading);
          uploadingResult.forEach((response) => {
            this.files.current.push(...response.files);
            this.files.uploading = [];
            this.notifySuccess(message);
          });
        } else {
          this.notifySuccess(message);
        }
      });
    },
    /**
     * @description Обработать удаление визита.
     * @param {number} visitId
     */
    async onDeleteVisit(visitId) {
      const dialog = await this.showRemoveDialog('Удалить визит безвозвратно?');
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      this.isAwaitRequest = true;
      const either = await this.$visitGateway.delete(this.patientId, visitId);
      either.forEach(({ message }) => {
        this.notifySuccess(message);
        this.visitList = this.visitList.filter((item) => item.id !== visitId);
        if (this.selectedVisitId === visitId) {
          this.selectedVisitId = -1;
          this.$router.replace({
            name: 'ClinicPanelPatientVisits',
            params: { patientId: this.patientId },
          });
        }
      });
      either.forEachFail((error) => {
        this.notifyFail(error.title);
      });
      this.isAwaitRequest = false;
    },
    /**
     * @description Обработать создание протокола приема.
     * @param {number} id    Идентификатор визита.
     * @param {Diary}  diary Протокол приема.
     * @returns {Promise<Validation>}
     */
    async onCreateDiary(id, diary) {
      const request = new CreateVisitDiaryRequest(id, diary);
      const result = await this.$visitGateway.createDiary(request);
      result.forEach(() => {
        diary.refresh();
        this.diariesIsChanged = false;
      });
      return result;
    },
    /**
     * @description Обработать редактирование протокола приема.
     * @param {number} id    Идентификатор визита.
     * @param {Diary}  diary Протокол приема.
     * @returns {Promise<Validation>}
     */
    async onEditDiary(id, diary) {
      const request = new EditVisitDiaryRequest(id, diary);
      const result = await this.$visitGateway.editDiary(request);
      result.forEach(() => {
        diary.refresh();
        this.diariesIsChanged = false;
      });
      return result;
    },
    /**
     * @description Отправить запрос на редактирование визита.
     * @param {number}       id     Идентификатор визита.
     * @param {PatientVisit} visit  Визит.
     * @returns {Promise<Validation>}
     */
    async onEditVisit(id, visit) {
      const crmDealOptions = this.needCreateCrmDeal ? await this.onResolveCreateCrmDeal() : null;
      const request = new EditPatientVisitRequest(
        visit.sanitized,
        visit.occlusion,
        visit.nsiConditionSeverenity,
        visit.nsiMedicalCarePaymentSource,
        visit.comment,
        id,
        crmDealOptions,
      );
      const result = await this.$visitGateway.editVisit(request);
      result.forEach(() => {
        visit.refresh();
        this.visitIsChanged = false;
      });
      return result;
    },
    /**
     * @description Обработать скачивание файла.
     * @param {any} file
     * @returns {void}
     */
    async onFileDownload(file) {
      if (file.id) {
        const either = await this.$visitGateway.downloadFile(this.selectedVisitId, file.id);
        either.fold(this.onRequestError, async (response) => {
          const { name } = this.files.current.find((item) => item.id === file.id);
          saveFile(response, name);
        });
      } else {
        saveFile(file, file.name);
      }
    },
    /**
     * @description Открыть файл для предпросмотра.
     * @param {File|{id:number,name:string}} file
     * @returns {void}
     */
    async onOpenFile(file) {
      this.isShowImage = true;
      this.imageSource = null;
      if (file.id) {
        const { name } = this.files.current.find((item) => item.id === file.id);
        this.dialogTitle = name;
        const either = await this.$visitGateway.downloadFile(this.selectedVisitId, file.id);
        either.fold(this.onRequestError, async (response) => {
          if (this.isImage(response.type, file.name)) {
            this.imageSource = URL.createObjectURL(response);
          } else {
            this.isShowImage = false;
            saveFile(response, file.name);
          }
        });
      } else if (this.isImage(file.type, file.name)) {
        this.dialogTitle = file.name;
        this.imageSource = URL.createObjectURL(file);
      } else {
        saveFile(file, file.name);
        this.isShowImage = false;
      }
    },
    /**
     * @description Сохранение визита и сформировать черновик в ЕГИСЗ.
     * @returns {Promise<void>}
     */
    async saveVisitAndFormingEgiszDraft() {
      const request = await this
        .editVisitAndFormingEgiszDraft(
          this.selectedVisitId,
          this.visit,
        )
        .then(async (result) => result.map((fields) => ({
          ...fields,
          hasImportantNotification: true,
        })));
      return this.editComponentsOfVisit(request);
    },
    /**
     * @description Сохранить визит.
     * @returns {Promise<void>}
     */
    async saveVisit() {
      const request = await this
        .onEditVisit(
          this.selectedVisitId,
          this.visit,
        )
        .then(async (result) => result.map((fields) => ({
          ...fields,
          hasImportantNotification: true,
        })));
      return this.editComponentsOfVisit(request);
    },
    /**
     * @description Обработать сохранение визита.
     * @returns {void}
     */
    onSaveVisit() {
      this.serviceTable.rows = this.serviceTable.rows.filter((item) => item.serviceId !== null);
      const process = this.isNewVisit ? this.onCreateVisit() : this
        .saveVisit()
        .then((result) => {
          result.forEachFail(({ message }) => { this.notifyFail(message); });
          result.forEach(({ message }) => {
            this.notifySuccessLong(message);
            this.reloadVisitList();
            const fetching = this.fetchVisit(this.selectedVisitId);
            if (this.canCheckCdaFields) {
              fetching.then(() => {
                this.fetchFullnessVisit(this.selectedVisitId);
              });
            }
          });
        });
      this.isAwaitRequest = true;
      process.finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать сохранение визита и сформировать черновик ЕГИСЗ.
     * @returns {void}
     */
    onSaveVisitAndFormingEgiszDraft() {
      this.serviceTable.rows = this.serviceTable.rows.filter((item) => item.serviceId !== null);
      const process = this.isNewVisit ? this.onCreateVisit() : this
        .saveVisitAndFormingEgiszDraft()
        .then((result) => {
          result.forEachFail(({ message }) => { this.notifyFail(message); });
          result.forEach(({ message }) => {
            this.notifySuccessLong(message);
            this.reloadVisitList();
            const fetching = this.fetchVisit(this.selectedVisitId);
            if (this.canCheckCdaFields) {
              fetching.then(() => {
                this.fetchFullnessVisit(this.selectedVisitId);
              });
            }
          });
        });
      this.isAwaitRequest = true;
      process.finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать установку времени.
     * @param {object}   times   Время начала.
     * @returns {void}
     */
    onSubmitTime(times) {
      this.visit.startsTime = times.startsTime;
      this.visit.endsTime = times.endsTime;
    },
    /**
     * @description Обработать изменение поля для поиска болезни.
     * @param {string} query
     * @returns {void}
     */
    onTextChange: debounce(function _(query) {
      this.queryDisease = query || '';
      if (!query || query.length === 0 || query.length > 500) {
        return;
      }
      this.fetchDiseases(query);
    }, 1000),

    /**
     * @description Редактировать визит и сформировать черновик ЕГИСЗ.
     *
     * @param {number}       id     Идентификатор визита.
     * @param {PatientVisit} visit  Визит.
     *
     * @returns {Promise<Validation>}
     */
    async editVisitAndFormingEgiszDraft(id, visit) {
      const crmDealOptions = this.needCreateCrmDeal ? await this.onResolveCreateCrmDeal() : null;
      const request = new EditPatientVisitRequest(
        visit.sanitized,
        visit.occlusion,
        visit.nsiConditionSeverenity,
        visit.nsiMedicalCarePaymentSource,
        visit.comment,
        id,
        crmDealOptions,
      );
      const result = await this.$visitGateway.editVisitAndFormingEgiszDraft(request);
      result.forEach(() => {
        visit.refresh();
        this.visitIsChanged = false;
      });
      return result;
    },
    /**
     * @description Обработать сохранение файлов.
     * @returns {Promise<Validation>}
     */
    async onUpdateFiles() {
      let result;
      let isError = false;
      if (this.files.deleting.length > 0) {
        result = await this.sendDeleteFileRequest(this.selectedVisitId, this.files.deleting);
        result.forEachFail(() => {
          isError = true;
        });
      }
      if (!isError && this.files.uploading.length > 0) {
        result = await this.sendUploadFilesRequest(this.selectedVisitId, this.files.uploading);
        result.forEach((response) => {
          this.files.current.push(...response.files);
          this.files.uploading = [];
        });
      }
      return result;
    },
    /**
     * @description Обработать сохранение таблицы услуг по Счетам.
     * @returns {Promise<Validation>}
     */
    async onUpdateServiceTableWithInvoices() {
      const result = await this
        .$visitGateway
        .editServices(this.selectedVisitId, this.invoices);
      result.forEach(() => {
        this.reloadVisitServiceList();
        this.invoices.refresh();
        this.invoiceTab = 0;
        this.invoicesIsChanged = false;
      });
      const isPartiallyStored = result.fold(
        () => false,
        (response) => response.is_partially_stored || false,
      );
      if (isPartiallyStored) {
        return Validation.fail({
          title: result.fold(() => '', ({ message }) => message),
          causes: [],
        });
      }
      return result;
    },
    /**
     * @description Обработать сохранение таблицы заказ-наряда.
     * @returns {Promise<Validation>}
     */
    async onUpdateWorkOrderTable() {
      const result = await this
        .$visitGateway
        .editWorkOrder(this.selectedVisitId, this.workOrderTable);
      result.forEach(() => {
        this.workOrderIsChanged = false;
      });
      return result;
    },
    /**
     * @description Открыть визит.
     * @param {number} id Идентификатор визита.
     * @returns {void}
     */
    openVisit(id) {
      if (this.visitId !== id) {
        this.beforeVisitLeave(() => this.fetchVisit(id));
      }
    },
    /**
     * @description Перезагрузить список визитов пациента.
     * @returns {void}
     */
    async reloadVisitList() {
      const { patientId } = this;
      if (Number.isNaN(patientId)) {
        return;
      }
      this.isAwaitRequest = true;
      const either = await this.$visitGateway.viewLatestList(patientId);
      either.forEach((list) => { this.visitList = list; });
      either.forEachLeft((error) => {
        this.notifyFail(error.title);
      });
      this.isAwaitRequest = false;
    },
    /**
     * @description Сохранить и продолжить.
     * @returns {void}
     */
    async saveAndLeave() {
      this.isDisabledPreventLeaveSaveButton = true;
      this.serviceTable.rows = this.serviceTable.rows.filter((item) => item.serviceId !== null);
      const result = await this.saveBeforeLeave();
      result.forEach(({ message }) => {
        this.notifySuccess(message);
        this.actionAfterClosingDialogLeaveConfirm();
      });
      this.isShownDialogLeaveConfirm = false;
      this.isDisabledPreventLeaveSaveButton = false;
    },
    /**
     * @description Сохранить перед выходом.
     * @returns {Promise<Validation>}
     */
    async saveBeforeLeave() {
      if (this.isNewVisit) {
        const result = await this.sendCreateVisitRequest(
          this.diaries,
          this.patientId,
          this.workOrderTable,
          this.serviceTable,
          this.dentalFormulaTeeth,
          this.visit,
        );
        result.forEach(async ({ message, visit_id: visitId }) => {
          if (this.files.uploading.length > 0) {
            const uploadingResult = await this.sendUploadFilesRequest(
              visitId,
              this.files.uploading,
            );
            uploadingResult.forEach((response) => {
              this.files.current.push(...response.files);
              this.files.uploading = [];
              this.notifySuccess(message);
            });
            uploadingResult.forEachFail(() => {
              this.reloadVisitList();
              this.fetchVisit(visitId);
              this.actionAfterClosingDialogLeaveConfirm = () => {};
            });
          } else {
            this.notifySuccess(message);
          }
        });
        return result;
      }
      return this.saveVisit();
    },
    /**
     * @description Отправить запрос на создание визита.
     * @param {array}        diaries        Протоколы приема.
     * @param {number}       patientId      Идентификатор пациента.
     * @param {any}          serviceTable   Таблица услуг.
     * @param {any}          workOrderTable Таблица услуг.
     * @param {any}          teeth          Зубная формула.
     * @param {PatientVisit} visit          Визит.
     * @returns {Promise<Validation>}
     */
    async sendCreateVisitRequest(diaries, patientId, serviceTable, workOrderTable, teeth, visit) {
      const creationRequest = new CreateVisitRequest(
        Object.values(teeth),
        diaries,
        patientId,
        serviceTable,
        workOrderTable,
        visit,
      );
      const result = await this.$visitGateway.createVisit(creationRequest);
      result.forEachFail((error) => {
        const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
        if (failurePairs.length === 0 && error.title) {
          this.notifyFail(error.title);
        }
        this.inputErrors = Object.fromEntries(failurePairs);
      });
      return result;
    },
    /**
     * @description править запрос на удаление файлов.
     * @param {number}   id    Идентификатор визита.
     * @param {number[]} files Идентификаторы файлов.
     * @returns {Promise<Validation>}
     */
    async sendDeleteFileRequest(id, files) {
      const result = await this.$visitGateway.deleteFiles(id, files);
      result.forEach(() => {
        this.files.current = this.files.current.filter(
          (file) => !this.files.deleting.includes(file.id),
        );
        this.files.deleting = [];
      });
      return result;
    },
    /**
     * @description Отправить запрос на загрузку файлов.
     * @param {number} id    Идентификатор визита.
     * @param {File[]} files Файлы.
     * @returns {Promise<Validation>}
     */
    async sendUploadFilesRequest(id, files) {
      const form = new FormData();
      for (let i = 0; i < files.length; i += 1) {
        form.append(`file[${i}]`, this.files.uploading[i]);
      }
      const result = await this.$visitGateway.uploadFiles(id, form);
      result.forEachFail((error) => {
        if (error.title) {
          this.notifyFail(error.title);
        }
        this.files.error = files;
      });
      return result;
    },
    /**
     * @description Скрыть или показать файлы протокола.
     * @returns void
     */
    toggleProtocolFiles() {
      this.isShowProtocolFiles = !this.isShowProtocolFiles;
    },
    /**
     * @description Получить индекс для использования во множественном числе.
     * @param {number} filesCount Количество файлов.
     * @returns {number}
     */
    getFilesPluralIndex(filesCount) {
      if (filesCount % 10 === 1 && filesCount % 100 !== 11) {
        return 0;
      }
      return (filesCount % 10 >= 2) && (filesCount % 10 <= 4)
      && ((filesCount % 100 < 10) || (filesCount % 100 >= 20)) ? 1 : 2;
    },
    /**
     * @description Получить строку с количеством загреженных фалйов.
     * @returns {string}
     */
    getCurrentFilesString() {
      if (!this.files.current.length) { return ''; }
      const index = this.getFilesPluralIndex(this.files.current.length);
      const pluralizationDictionary = ['файл', 'файла', 'файлов'];
      return `(${index ? 'добавлено' : 'добавлен'} ${this.files.current.length} ${pluralizationDictionary[index]})`;
    },
  },
  mixins: [
    addingServicesFromPriceMixin,
    addingServicesFromTreatmentPlansMixin,
    builtInDialogMixin,
    chiefPhysicianMixin,
    dateMixin,
    dentalFormulaMixin,
    diaryLibraryMixin,
    diseaseMixin,
    iemkMixin,
    invoiceLocalMixin,
    notifierMixin,
    popoverMixin,
    preventLeaveWithoutConfirmMixin,
    printDocumentsLocalMixin,
    visitServiceMixin,
    visitNoteMixin,
    crmDealMixin,
    TeethGroupMixin,
    mobileMixin,
    mobilePopupMixin,
    metricMixin,
  ],
  name: 'ClinicPanelPatientVisit',
  props: {
    /**
     * @description Начальный список визитов.
     * @type {object[]}
     */
    initialVisitList: {
      default: () => [],
      type: Array,
    },
  },
  watch: {
    allowedTimes(value) {
      const includes = (time) => !!value.find((item) => item.title === time);
      const { endsTime, startsTime } = this.visit;
      if (startsTime && !includes(startsTime)) {
        this.visit.startsTime = null;
      }
      if (endsTime && !includes(endsTime)) {
        this.visit.endsTime = null;
      }
    },
    'visit.date': {
      handler(value) {
        if (value) {
          let timeStep = 5;
          if (this.visit.employeeId && this.isNewVisit) {
            const employee = this.workingEmployeesList.find((item) => item.id === value);
            timeStep = employee.timeStep;
          }
          this.fetchWorkingEmployees(value, timeStep);
        }
      },
    },
    'visit.employeeId': {
      async handler(value) {
        const year = this.visit.date.getFullYear();
        const month = (this.visit.date.getMonth() + 1).toString().padStart(2, '0');
        const yearAndMonth = `${year}-${month}`;
        const employee = this.workingEmployeesList.find((item) => item.id === value);
        if (employee && this.isNewVisit) {
          this.isNeedInitializeTime = true;
          this.fetchTimeLineForNewVisitWithSelectedEmployee(this.visit.date, employee.timeStep);
        }
        if (value) {
          this.workDays = await this.fetchEmployeeWorkDays(value, yearAndMonth);
        } else {
          this.workDays = await this.fetchClinicWorkDays(yearAndMonth);
        }
      },
    },
    visit: {
      handler(value) {
        this.visitIsChanged = value.isChanged();
      },
      deep: true,
    },
    diaries: {
      handler: debounce(
        function update(value) {
          this.diariesIsChanged = JSON.stringify(value) !== this.initialDiaries;
        },
        300,
      ),
      deep: true,
    },
    files: {
      handler(value) {
        this.filesIsChanged = value.uploading.length + value.deleting.length > 0;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";

.diary-tab {
  display: grid;
  grid-template: "form library" "form library" / 1fr 1fr;
  gap: 10px;
  width: 100%;
  @media screen and (max-width: 600px) {
    grid-template: "form";
    gap: 20px;
  }
  .patient-visits__diary__column {
    grid-area: form;
  }
}
.show-image {
  &__container {
    position: relative;
    flex: 1;
    img {
      height: 100%;
      object-fit: contain;
      width: 100%;
    }
  }
}
.patient {
  &-profile {
    &__visit {
      max-width: 100%;
      width: 100%;
      height: 100%;
    }
    &__show-image {
      object-fit: cover;
    }
    &__print {
      display: none;
    }
    &__modal {
      &__button {
        @include buttons.btn-blue(100%, 48px, 16px);
        margin: 20px auto 0 auto;
        max-width: 174px;
      }
    }
  }
}
.text__violation {
  color: var(--warning-color);
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  padding: 0.125rem;
}
.patient-visits {
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  margin-bottom: 40px;
  &__refund-egisz-title {
    font-size: 16px;
    font-weight: bold;
  }
  &__print-button {
    @include buttons.btn-blue(100%, 46px, 1rem);
    max-width: 150px;
  }
  &__section {
    margin: 25px 0 0 0;
    position: relative;
  }
  &__slider {
    pointer-events: none;
    transform: translateY(-26px);
  }
  &__slide {
    text-decoration: none;
    text-align: left;
    background: #eaeff3;
    border-radius: 4px;
    padding: 14px 19px;
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    color: #192a3e;
    margin: 0 3px;
    cursor: pointer;
    border: 2px solid transparent;
    min-height: 117px;
    &.active {
      border: 2px solid #0489e0;
    }
    &.router-link-active {
      border: 2px solid #0489e0;
      color: #0489e0;
    }
    &:hover {
      border: 2px solid #0489e0;
    }
    &__row {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;
      margin: 0 0 5px 0;
    }
    &__name {
      color: #90a0b7;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
    }
    &__icon-delete {
      align-self: center;
      justify-self: center;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
    &__times {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      margin: 10px 0;
      font-size: 17px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      color: #192A3E;
    }
    &__time {
      color: #0489e0;
      &:hover {
        color: #192A3E;
      }
    }
    &__text {
      font-size: 17px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      color: #192A3E;
      margin: 0 0 5px 0;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    &__diseases-text {

    }
    &__doctor {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      gap: 10px;
      margin: -5px 0 0 0;
      .v-text-field {
        padding-top: 0;
        margin-top: 0;
      }
    }
  }
  &__dental-formula {
    overflow: hidden;
    .patient-section__body {
      margin: 25px 0 0 -24px;
    }
    .v-expansion-panel-content__wrap {
      overflow-x: auto;
    }
  }
  &__empty {
    text-align: left;
    font-size: 18px;
    cursor: pointer;
    b {
      color: var(--action-color);
    }
  }
  &__visits {
    display: flex;
    flex-direction: column;
    gap: 6px;
    &__item {
      background: #eaeff3;
      border-radius: 4px;
      transition: border var(--animate-duration);
      padding: 13px 16px;
      border: 2px solid #eaeff3;
      &:hover {
        border: 2px solid #0489e0;
      }
      &__name {
        color: #90a0b7;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
      }
      time {
        color: #192a3e;
        font-size: 17px;
        font-weight: 500;
        line-height: 20px;
      }
    }
  }
  &__sections {
    z-index: 0;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    width: 100%;
    gap: 13px;
  }
  &__visit {
    background-color: #f2f5f8 !important;
    padding: 26px 26px 34px;
    width: 100%;
    &__files {
      background-color: chocolate;
      .patient-section__body {
        margin: 20px 0 0 -24px;
      }
    }
    &__row {
      display: grid;
      align-items: center;
      column-gap: 10px;
      grid-template-columns: 1fr 174px 174px;
    }
    &__group {
      align-items: center;
      display: grid;
      grid-template-columns: repeat(3, min-content) 1fr;
      white-space: nowrap;
      width: 100%;
      & > p {
        font-size: 24px;
        font-weight: 600;
        line-height: 29px;
        margin: 0 25px 0 0;
      }
    }
    &__datetime {
      color: var(--action-color);
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
      margin-right: 18px;
      border-bottom: 1px solid #abd5f1;
      cursor: pointer;
      width: fit-content;
      &:hover {
        border-bottom: 1px solid transparent;
      }
    }
    &__button {
      &-save {
        @include buttons.btn-blue(100%, 48px, 16px);
        margin: 0;
        max-width: 174px;
        padding: 0;
        &:disabled {
          background-color: var(--unfocus-color);
        }
      }
      &-print {
        @include buttons.btn-transparent(100%, 48px, 16px);
        position: relative;
        background-color: transparent;
        max-width: 174px;
        padding: 0;
        margin: 0;
        &:before {
          content: "";
          background-image: url("@/assets/img/print.svg");
          background-repeat: no-repeat;
          background-size: contain;
          width: 24px;
          height: 24px;
          margin: 0 8px 0 0;
        }
        &:disabled {
          background-color: var(--unfocus-color);
          &:before {
            background-image: url("@/assets/img/print-white.svg");
          }
        }
      }
      &-download {
        @include buttons.btn-transparent(100%, 48px, 16px);
        background-color: transparent;
        max-width: 174px;
        padding: 0;
        margin: 0;
        &:disabled {
          background-color: var(--unfocus-color);
          &:before {
            background-image: url("@/assets/img/print-white.svg");
          }
        }
      }
    }
    &__doctor {
      display: flex;
      flex-direction: row;
      grid-gap: 15px;
      font-weight: 400;
      color: #192a3e;
      font-size: 16px;
      line-height: 19px;
      margin: 20px 0 0 0;
      align-items: center;
      width: fit-content();
      &__name {
        font-weight: 600;
        max-width: auto;
        min-width: 250px;
        flex: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &.v-text-field {
          padding-top: 0;
          margin-top: 0;
        }
      }
    }
    &__bite {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 20px;
      p {
        margin: 0;
      }
      &__container {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 8px 14px;
        font-size: 16px;
        font-weight: 400;
        background-color: #ffffff;
        border-radius: 40px;
        .v-input--selection-controls__input:hover
        .v-input--selection-controls__ripple:before {
          content: none;
        }
        .theme--light.v-input--switch .v-input--switch__track {
          background: #eaeff3 !important;
          border: 1px solid #c2cfe0;
          border-radius: 15px;
        }
        .theme--light.v-input--switch .v-input--switch__thumb {
          color: #90a0b7;
        }
        .v-input--selection-controls {
          margin: 0 !important;
          padding: 5px !important;
        }
      }
      &__switch {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      & &__select {
        .select__select {
          border-radius: 32px;
        }
      }
      &__title {
        font-weight: 400;
        font-size: inherit;
        line-height: 17px;
        color: #192a3e;
      }
    }
    &__checkbox {
      position: absolute;
      z-index: -1;
      opacity: 0;
      &:checked + label:before {
        background: rgba(4, 137, 224, 0.18);
        border: 1px solid #0489e0;
      }
      &:checked + label:after {
        left: 16px;
        background: #0489e0;
      }
    }
    &__checkbox + label {
      position: relative;
      padding: 0 0 16px 40px;
      cursor: pointer;
    }
    &__checkbox + label:before {
      content: "";
      position: absolute;
      top: -4px;
      left: 0;
      width: 38px;
      height: 24px;
      border-radius: 15px;
      background: #eaeff3;
      border: 1px solid #c2cfe0;
      transition: 0.2s;
    }
    &__checkbox + label:after {
      content: "";
      position: absolute;
      top: -2px;
      left: 2px;
      width: 20px;
      height: 20px;
      border-radius: 10px;
      background: #90a0b7;
      transition: 0.2s;
    }
    &__oral {
      margin: 0 0 10px 0;
      overflow: scroll;
      &__title {
        flex-direction: row;
        display: flex;
        align-items: center;
        gap: 32px;
      }
      &__switch {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 20px;
        p {
          margin: 0;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: var(--reading-color);
        }
        .v-input--selection-controls__input:hover,
        .v-input--selection-controls__ripple:before {
          content: none;
        }
        .v-input--selection-controls__ripple {
          display: none;
        }
        .v-input--switch .v-input--switch__track {
          background: white !important;
          border: 1px solid #c2cfe0;
          border-radius: 15px;
          opacity: 1 !important;
        }
        .v-input--switch .v-input--switch__thumb {
          color: #90a0b7;
        }
        .v-input--selection-controls {
          margin: 0 !important;
          padding: 5px !important;
        }
      }
      &__container {
        display: flex;
        flex-direction: column;
        gap: 32px;
        margin: 18px 0 0 0;
        width: min-content;
      }
      &__legend {
        min-width: 370px;
        &__items {
          margin-top: 20px;
          display: grid;
          grid-row: 5;
          grid-template-columns: repeat(2, minmax(130px, auto));
          align-items: center;
          gap: 5px 22px;
        }
        &__item {
          height: 24px;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          flex-direction: row;
          display: flex;
          color: #192a3e;
          align-items: center;
          gap: 4px;
          &__name {
            min-width: 20px;
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
          }
          &__description {
            font-weight: 400;
            font-size: 14px;
            line-height: 17px;
            color: #707683;
          }
        }
      }
    }
  }
  &__diary,
  .form-visit-diary {
    display: flex;
    flex-direction: column;
    gap: 20px;
    .collapse-field__caption {
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #192a3e;
      margin: 0 0 10px 0;
      text-align: left;
    }
  }
  &__diary {
    &__tabs {
      margin-top: 20px;
      background-color: transparent !important;
      overflow: initial !important;
    }
    &__tab {
      display: flex;
      gap: 10px;
      flex-direction: column;
      &__head {
        display: flex;
        gap: 10px;
      }
      &__name {
        color: var(--unfocus-color);
      }
    }
    &__tabs-services {
      margin-bottom: 30px;
    }
    &__column {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    &__text {
      color: #0489e0;
      cursor: pointer;
      &:hover {
        color: #192a3e;
      }
      span {
        color: #000000;
      }
    }
    &__description {
      color: var(--unfocus-color);
      font-size: 1rem;
      margin-bottom: 10px;
    }
    &__block {
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #192a3e;
      margin: -15px 0 0 0;
    }
    &__buttons {
      display: grid;
      grid-template-columns: 240px 207px;
      &__button {
        &-cancel {
          @include buttons.btn-transparent(256px, 48px, 16px);
        }
        &-print {
          @include buttons.btn-transparent(256px, 48px, 16px);
          background-color: transparent;
          &:before {
            content: "";
            background-image: url("@/assets/img/print.svg");
            background-repeat: no-repeat;
            background-size: contain;
            width: 24px;
            height: 24px;
            margin: 0 8px 0 0;
          }
          &:disabled {
            border-color: var(--unfocus-color);
            color: var(--unfocus-color);
            background-color: transparent;
            &:before {
              background-image: url("@/assets/img/print-grey.svg");
            }
          }
        }
      }
    }
    &__disease {
      display: none;
    }
    &__input {
      background: #ffffff;
      border: 1px solid #c2cfe0 !important;
      border-radius: 4px;
      outline: none;
      height: 40px;
      width: 100%;
      padding: 0 10px;
      appearance: none;
      font-size: 16px;
      color: #192a3e;
      font-weight: 400;
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 2px solid #0489e0 !important;
        outline: 0;
      }
      &:disabled {
        background-color: #fff;
      }
      &.snils {
        width: 333px;
      }
      &.belay {
        width: 720px;
      }
      &.key {
        width: 172px;
      }
      &.search {
        max-width: 100%;
        padding: 0 42px;
        &:focus {
          padding: 0 41px;
        }
      }
      &.date {
        width: 266px;
      }
    }
    &__search {
      position: relative;
      max-width: 100%;
      .v-input {
        &__append-outer {
          margin-left: 0 !important;
        }
      }
      & .v-input__slot {
        min-height: 38px !important;
        & > .v-select__slot {
          & > input {
            padding-left: 35px;
          }
          & > .v-input__append-inner {
            margin-top: 7px !important;
            margin-left: 25px !important;
          }
        }
      }
    }
    &__icon-search {
      position: absolute;
      left: 7px;
      top: 10px;
      background-repeat: no-repeat;
      background-image: url("@/assets/img/search-black.svg");
      background-size: contain;
      width: 20px;
      height: 18px;
    }
    &__icon-file {
      position: absolute;
      right: 1px !important;
      top: 2px !important;
      background-repeat: no-repeat;
      background-image: url("@/assets/img/file.svg");
      background-position: center;
      background-color: #eaeff3;
      border-radius: 0 3px 3px 0;
      width: 35px;
      height: 34px;
    }
    &.tooth {
      display: flex;
      align-items: center;
      flex-direction: row;
      gap: 20px;
      color: #0489e0;
      cursor: pointer;
      white-space: nowrap;
      &:after {
        content: '';
        background-image: url("@/assets/img/tooth.svg");
        background-size: contain;
        background-repeat: no-repeat;
        width: 100%;
        height: 30px;
      }
      &:hover {
        color: #192a3e;
      }
    }
  }
  &__diary-template {
    max-width: 737px;
  }
  &__protocol {
    &__files {
      &__title {
        display: flex;
        align-items: center;
        margin-top: 30px;
        margin-bottom: 15px;
        font-size: 18px;
        line-height: 25px;
        color: var(--action-color);
        &::before {
          content: "";
          background-image: url("@/assets/img/paperclip-blue.svg");
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          margin: 0 10px 0 0;
          width: 25px;
          height: 25px;
        }
      }
    }
    &__name {
      padding: 4px;
      font-family: inherit;
      font-size: 14px;
      color: rgba(0, 0, 0, .54);
      letter-spacing: 1.25px;
      text-transform: uppercase;
      background-color: #ffffff;
      outline: 1px solid var(--action-color);
    }
    &__buttons {
      display: grid;
      grid-template-columns: 266px 248px;
      gap: 9px;
      margin: 30px 0 0 0;
    }
    &__add {
      @include buttons.btn-transparent(100%, 48px, 16px);
      &.min {
        width: 200px;
      }
    }
    &__icon-edit {
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 15px;
      min-width: 15px;
      height: 15px;
      min-height: 15px;
      padding: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &__delete {
      display: inline-flex;
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      background-image: url("@/assets/img/exit-grey.svg");
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
    &__single-add {
      @include buttons.btn-transparent-add(32px);
    }
  }
  &__files {
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 2px dashed #c2cfe0;
    border-radius: 2px;
    padding: 32px;
    align-items: center;
    p {
      margin: 18px 0 0 0;
      max-width: 395px;
      color: #90a0b7;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
    }
  }
  &__buttons {
    display: flex;
    flex-flow: row wrap;
    gap: 20px;
    margin: 40px 0 0 0;
  }
  &__button-save {
    @include buttons.btn-blue(100%, 48px, 16px);
    max-width: 178px;
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__button-egisz-save {
    @include buttons.btn-blue(100%, 48px, 16px);
    background-color: #1EBFBF;
    color: #FFFFFF;
    &:hover {
    background-color: #158c8c;
    transition: all 0.3s ease 0s;
  }
    max-width: 266px;
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__button-blue {
    @include buttons.btn-blue(100%, 32px, 14px);
    max-width: 170px;
    &:disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__button-create {
    @include buttons.btn-blue(100%, 48px, 16px);
    @include buttons.btn-blue-add(16px);
    max-width: 299px;
  }
  &__services {
    width: 100%;
    &__search-input {
      width: 100%;
    }
    &__row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      &__adding-service {
        display: grid;
        grid-template-columns: auto auto;
        column-gap: 10px;
      }
    }
    &__title {
      font-size: 24px;
      font-weight: 600;
      line-height: 29px;
    }
    &__button {
      @include buttons.btn-transparent(100%, 40px, 16px);
      padding: 0 10px;
      &.check {
        max-width: 250px;
        @include buttons.btn-transparent(100%, 48px, 16px);
        @include buttons.btn-transparent-add(16px);
      }
      &.invoice {
        width: auto;
        text-decoration: none;
      }
      &.tab-add {
        align-self: center;
        margin-left: 10px;
        @include buttons.btn-plus-color-add;
      }
    }
    &__tab {
      &__head {
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: center;
      }
      &__name {
        color: var(--unfocus-color);
      }
    }
  }
  &__treatment-plans {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1000px;
    gap: 15px;
    &__items {
      padding-left: 0 !important;
      list-style: none;
    }
    &__buttons {
      column-gap: 9px;
      display: grid;
      grid-template-columns: 180px 180px;
      &-submit {
        @include buttons.btn-blue(100%, 48px, 16px);
      }
      &-cancel {
        @include buttons.btn-transparent(100%, 48px, 16px);
      }
    }
    &__plan-checkbox {
      & > input {
        opacity: 0;
        position: absolute;
        z-index: -1;
      }
      & > input:focus+span::before {
        border-color: var(--action-color);
      }
      &::before {
        background-color: var(--primary-background-color);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 70%;
        border: 1px solid var(--unfocus-color);
        border-radius: 4px;
        content: '';
        display: inline-block;
        flex-grow: 0;
        flex-shrink: 0;
        height: 1.5rem;
        margin: 0 10px 0 0;
        width: 1.5rem;
      }
      &.any::before {
        background-color: var(--action-color);;
        background-image: url("@/assets/img/minus.svg");
      }
      &.all::before {
        background-color: var(--action-color);
        background-image: url("@/assets/img/checked/checked-white-top.svg");
      }
      &.selected>input:focus+span::before {
        border-color: black;
      }
      &.empty::before{
        background-color: var(--primary-background-color);
        background-image: none;
      }
    }
  }
  &__picker-services {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
  &__form-notes {
    display: grid;
    row-gap: 15px;
  }
  &__notes {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-block: 16px;
    &__show-more {
      @include buttons.btn-transparent(100%, 32px, 14px);
      max-width: 150px;
      align-self: center;
    }
  }
  &__notes-count {
    color: #F5222D;
    margin-left: 5px;
  }
  &__note {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-block: 14px 8px;
    padding-inline: 8px;
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #c2cfe0;
    &.new {
      background: #0091E91A;
    }
    &.is-edit {
      padding-right: 55px;
    }
    &__info {
      display: flex;
      gap: 6px;
      font-size: 12px;
      font-weight: 400;
      color: #929fb3
    }
    &__actions {
      position: absolute;
      top: 12px;
      right: 12px;
      display: flex;
      gap: 8px;
      margin-left: auto;
    }
    &__action {
      width: 15px;
      height: 15px;
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
      &.edit {
        background-image: url("@/assets/img/pen-grey.svg");
        &:hover {
          background-image: url("@/assets/img/pen-blue.svg");
        }
      }
      &.delete {
        background-image: url("@/assets/img/exit-grey.svg");
        &:hover {
          background-image: url("@/assets/img/exit-blue.svg");
        }
      }
    }
    &__content {
      max-height: 310px;
      font-weight: 400;
      font-size: 16px;
      color: #000000;
      white-space: pre-wrap;
      overflow-y: auto;
      p {
        margin: 0;
        overflow-wrap: anywhere;
      }
    }
    &__edit-buttons {
      display: flex;
      gap: 10px;
      margin-top: 5px;
    }
    &__button-save {
      @include buttons.btn-blue(min(100%, 120px), 40px, 14px);
      padding: 0 10px;
    }
    &__button-cancel {
      @include buttons.btn-transparent(min(100%, 120px), 40px, 14px);
      padding: 0 10px;
    }
  }
}
.teeth-formula {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 19px 10px;
  border-radius: 8px;
  overflow: hidden;
  gap: 17px;
  &__row {
    display: grid;
    grid-template-columns: repeat(16, 68px);
    align-items: center;
    text-align: center;
  }
}
.title {
  position: absolute;
  z-index: 2;
}
.disable-component {
  pointer-events: none;
}
.print-visit-form {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  &__diaries {
    list-style: none;
    padding: 0 !important;
  }
  &__document {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    &--print {
      display: grid;
      grid-template-columns: 95px 1fr auto auto;
    }
    &__title {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
    &__format {
      display: flex;
      gap: 10px;
      font-size: 14px;
      label {
        display: flex;
        align-items: center;
        gap: 5px;
        cursor: pointer;
      }
    }
    &__button {
      &-print {
        content: "";
        grid-column: 4;
        width: 22px;
        height: 22px;
        background: no-repeat 50%;
        background-image: url("@/assets/img/print.svg");
        background-size: contain;
      }
    }
    &__count {
      input {
        border-bottom: 1px solid #C2CFE0;
        box-sizing: border-box;
        appearance: textfield;
        text-align: center;
        height: 30px;
        width: 30px;
        margin: 0 7px;
        color: #707683;
        font-size: 14px;
        &:focus {
          color: #192a3e;
          background-color: #fff;
          border-bottom: 1px solid #0489e0 !important;
          outline: 0;
        }
        &:disabled {
          background-color: #fff;
        }
      }
    }
    &__date {
      input {
        border-bottom: 1px solid #C2CFE0;
        box-sizing: border-box;
        appearance: textfield;
        text-align: center;
        height: 30px;
        width: 120px;
        margin: 0 7px;
        color: #707683;
        font-size: 14px;
        &:focus {
          color: #192a3e;
          background-color: #fff;
          border-bottom: 1px solid #0489e0 !important;
          outline: 0;
        }
        &:disabled {
          background-color: #fff;
        }
      }
    }
  }
  &__button {
    @include buttons.btn-blue(100%, 32px, 12px);
    max-width: 150px;
    align-self: flex-end;
  }
}
.mdi-menu-down::before {
  content: "";
  background-image: url("@/assets/img/checked/checked-grey.svg");
  background-size: contain;
  background-position: center;
  width: 12px;
  height: 10px;
  cursor: pointer;
}
.visit-iemk-status {
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 15px 0 0 0;
  &.fail,
  &.success,
  &.none {
    border: 1px solid #c2cfe0;
    &:before {
      content: '';
      height: 20px;
      min-height: 20px;
      margin-right: 10px;
      width: 20px;
      min-width: 20px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
  &.fail {
    background-color: #FFECEC;
    &:before {
      background-image: url("@/assets/img/exit-red.svg");
    }
  }
  &.success {
    background-color: #E4FFEC !important;
    &:before {
      background-image: url("@/assets/img/checked/all-checked-green.svg");
    }
  }
  &.none:before {
    height: 6px;
    min-width: 6px;
    width: 6px;
    min-height: 6px;
    background: #ABB1A3;
    border-radius: 50%;
    margin: 0 10px 0 6px;
  }
}
.visit-chief-physician-status {
  padding: 10px;
  margin: 15px 0 0 0;
  border: 1px solid #c2cfe0;
  &__title {
    display: flex;
    align-items: center;
    &.new {
      gap: 14px;
      &:before {
        width: 6px;
        height: 6px;
        background-color: #abb1a3;
        border-radius: 50%;
        content: "";
      }
    }
    &.to-verify {
      gap: 12px;
      &:before {
        width: 10px;
        height: 10px;
        border: 2px solid #faa525;
        border-radius: 50%;
        content: "";
      }
    }
    &.rejected {
      color: var(--warning-color);
      gap: 7px;
      &:before {
        background-image: url("@/assets/img/exit-red.svg");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
        height: 20px;
        width: 20px;
      }
    }
    &.verified {
      gap: 7px;
      &:before {
        background-image: url("@/assets/img/checked/all-checked-green.svg");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
        height: 20px;
        width: 20px;
      }
    }
  }
}

@media screen and (max-width: 820px) {
  .patient-visits {
    &__visit {
      &__row {
        grid-template-columns: 1fr;
        grid-gap: 20px;
        align-items: flex-start;
      }
    }
    &__services {
      &__row {
        align-items: flex-start;
        gap: 10px;
        flex-direction: column;
      }
    }
    &__protocol {
      &__buttons {
        grid-template-columns: 1fr;
        gap: 10px;
      }
    }
    &__diary {
      &__buttons {
        &__button-print {
          width: 100%;
        }
      }
    }
  }
}

@media screen and (max-width: 720px) {
  .patient-visits {
    &__visit {
      &__bite {
        flex-direction: column;
        grid-gap: 20px;
        align-items: flex-start;
        &__container {
          margin-left: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 620px) {
  .patient-visits {
    &__visit {
      &__group {
        grid-template-columns: 1fr;
        grid-gap: 10px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .patient-visits {
    &__diary {
      &__tabs-services {
        margin-bottom: 10px;
      }
      &__buttons__button-print {
        display: none;
      }
    }
    &__visit {
      padding: 20px 15px;
      &__doctor {
        &__name {
          min-width: 160px;
        }
      }
      &__button-print {
        display: none;
      }
      &__bite {
        &__select {
          width: 100%;
        }
      }
    }
    &__services {
      &__row {
        flex-direction: column;
        grid-gap: 20px;
        align-items: flex-start;
        &__adding-service {
          grid-template-columns: 1fr;
          row-gap: 20px;
          width: 100%;
        }
      }
      &__button {
        &.invoice,
        &.check {
          width: 100%;
          max-width: none;
        }
      }
    }
    &__protocol {
      &__add {
        max-width: 100%;
        margin: 0;
      }
    }
  }
}

@media screen and (max-width: 380px) {
  .patient-visits {
    &__services {
      &__button {
        height: 48px;
      }
    }
  }
}
</style>
